import { DataGrid } from "@mui/x-data-grid";
import { Paper, Typography, Button, MenuItem, Select, FormControl, Checkbox, FormControlLabel, InputLabel, Dialog, Table, TableRow, FormGroup, Collapse, TableCell, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GetRole from "./user";
import { useEffect, useState } from "react";
import {preventDoubleClick} from "./preventDC.js"
import {CSVLink} from "react-csv"
import {
  fetchActiveTrips,
  newupdateLeaddata,
  fetchRules,
  todaysignin,
  searchTripsbyStartDateandowner,
  fetchActiveTripsbyTripOwner,
  fetchConvertedTripsbyTripOwner,
  fetchOpenCustomers,
  fetchfunnelsize,
  fetchQuotebyIdGroup,
  currentfupcount,
  openfupcountbysp,
  fetchCustomersbyOwner,
  fetchLeads,
  fetchLeadsbyTripOwner,
  fetchEmployees,
  fetchDest,
  fetchLeadbyId,
  updateLeaddata,
  fetchCancbyOwner,
  fetchCanc,
  addTCLeads,
  fetchTripsbyStatusandOwner,
  fetchTripsbyStatus,
  fetchConvertedTripsOnly,
  fetchConvertedTripsbyTL,
  fetchCancbyTL,
  fetchLeadsbyTL,
  fetchleadsbynumber2,
  fetchCustomersbyTL,
  newupdateCustdata,
  fetchQuotebyId,
  searchTripsbyStartDate,
  fetchLeadsTodaybyTripOwner,
  canceltripbytripid,
  fetchTeambyName,
  fetchopentasks,
  fetchTasksbyOwner,
  fetchTripsbyNumber,
  fetchcancflagbydateandowner,
  fetchLeads15,
  fetchdupTripsbyNumber,
  fetchcancflagbydate,
  searchQCbyDateandOwner,
  searchQEbyDateandOwner,
  newsearchQEbyDateandOwner,
  fetchfunnellength,
  get12pmreport
} from "../api/customerapi";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DateCalc, { removeDuplicates } from "./date";
import { getquality, newgetqualitylead, calltrue2, total, sptotal, gettcs, gettaxes, pending, getprofit, checkquotefault } from "./date";


const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(4),
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
  },
  headertext: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(20),
    height: theme.spacing(4),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    fontSize: 10,
  },
  formgroup: {
    justifyContent: "center",   
},
}));

const Homeview = () => {
  const classes = useStyles();
  const width = window.innerWidth - 200;
  //console.log(width);
  const fcolumns = [
    {
      field: "trip_id",
      headerName: " Trip ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: width / 12,
    },
    {
      field: "date",
      headerName: "Followup Date",
      width: width / 12,
    },
    {
      field: "time",
      headerName: "Followup Time",
      width: width / 12*0.75,
    },
    {
      field: "prev_note",
      headerName: "Last followup note",
      width: (width / 12) * 2,
    },
    {
      field: "current_note",
      headerName: "Current followup note",
      width: (width / 12) * 2,
    },
    {
      field: "fup_type",
      headerName: "Followup Type",
      width: (width / 12) * 1,
    },
    {
      field: "trip_status",
      headerName: "Trip Status",
      width: width / 12*0.75,
    },
    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12*0.75,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12),
    },
    {
      field: "potential",
      headerName: "Potential",
      width: (width / 12)*0.75,
    },
    {
      field: "qp",
      headerName: "QP?",
      width: (width / 12),
    },
    {
      field: "trip_created_date",
      headerName: "Created Date",
      width: (width / 12)*1.5,
    },
    
    
  ];

  const fcolumns2 = [
    {
      field: "trip_id",
      headerName: " Trip ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: width / 12,
    },
    {
      field: "pna",
      headerName: "PNA",
      width: width / 12*2,
    },
    {
      field: "date",
      headerName: "Followup Date",
      width: width / 12,
    },
    {
      field: "time",
      headerName: "Followup Time",
      width: width / 12,
    },
    {
      field: "prev_note",
      headerName: "Last followup note",
      width: (width / 12) * 1.5,
    },
    {
      field: "current_note",
      headerName: "Current followup note",
      width: (width / 12) * 1.5,
    },
    {
      field: "fup_type",
      headerName: "Followup Type",
      width: (width / 12) * 1,
    },
    {
      field: "trip_status",
      headerName: "Trip Status",
      width: width / 12,
    },
    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12),
    },
    {
      field: "potential",
      headerName: "Potential",
      width: (width / 12),
    },
    {
      field: "qp",
      headerName: "QP?",
      width: (width / 12),
    },
    {
      field: "lead_status",
      headerName: "Status",
      width: (width / 12),
    },
    {
      field: "trip_created_date",
      headerName: "Created Date",
      width: (width / 12)*1.5,
    },
    
  ];

  const fcolumns3 = [
    {
      field: "trip_id",
      headerName: " Trip ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: width / 12,
    },
    {
      field: "date",
      headerName: "Followup Date",
      width: width / 12,
    },
    {
      field: "time",
      headerName: "Followup Time",
      width: width / 12,
    },
    {
      field: "current_note",
      headerName: "Current followup note",
      width: (width / 12) * 1.5,
    },
    {
      field: "qp",
      headerName: "QP?",
      width: (width / 12),
    },
    {
      field: "trip_status",
      headerName: "Trip Status",
      width: width / 12,
    },
    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12),
    },
    {
      field: "call_must",
      headerName: "Call Must",
      width: (width / 12),
    },
    {
      field: "call_attempted",
      headerName: "Call Done?",
      width: (width / 12)*2,
    },
    {
      field: "potential",
      headerName: "Potential",
      width: (width / 12),
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: (width / 12)*2,
    },
  ];

  const ccolumns = [
    {
      field: "cust_id",
      headerName: " Cust ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: (width / 12) * 2,
    },
     {
      field: "last_assigned_by",
      headerName: "Last Assigned By",
      width: (width / 12),
    },
    {
      field: "date",
      headerName: "Followup Date",
      width: width / 12,
    },
    {
      field: "time",
      headerName: "Followup Time",
      width: width / 12,
    },
    {
      field: "note",
      headerName: "Followup Notes",
      width: (width / 12) * 2,
    },
    {
      field: "owner",
      headerName: "Owner",
      width: (width / 12),
    },
    {
      field: "dest",
      headerName: "Destination",
      width: (width / 12),
    },
     {
      field: "lead_owner",
      headerName: "Lead Owner",
      width: (width / 12),
    },
  ];

  const pcolumns = [
    {
      field: "trip_id",
      headerName: " Trip ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: (width / 12) * 2,
    },
     {
      field: "urgent",
      headerName: "Urgent",
      width: (width / 12) * 1,
    },
    {
      field: "date",
      headerName: "Collection Date",
      width: (width / 12) ,
    },
    {
      field: "amount",
      headerName: "Collection Amount",
      width: (width / 12) ,
    },
    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: (width / 12) ,
    },
   
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) ,
    },
    {
      field: "payment_note",
      headerName: "Note",
      width: (width / 12)*2 ,
    }
  ];
  const pcolumns2 = [
    {
      field: "trip_id",
      headerName: " Trip ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "name",
      headerName: " Supplier Name",
      width: (width / 12) * 2.5,
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: (width / 12) * 2.5,
    },
    
    {
      field: "date",
      headerName: "Payment Date",
      width: (width / 12) * 2,
    },
    {
      field: "amount",
      headerName: "Payable Amount",
      width: (width / 12) * 2,
    },
    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: (width / 12) * 2,
    },
    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) ,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) ,
    },
  ];

  const pheaders2=[
    {label:"Owner", key:"trip_owner"},
    {label:"Name", key:"cust_name"},
    {label:"Trip Id", key:"trip_id"},
    {label:"Supplier Name", key:"name"},
    {label:"Ops Owner", key:"ops_owner"},
     {label:"Trip Start Date", key:"trip_start_date"},
     {label:"Payable Amount", key:"amount"},
     {label:"Payable Date", key:"date"},
  ]
  const pcolumns3 = [
    {
      field: "trip_id",
      headerName: " Trip ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: "Customer Name",
      width: (width / 12) * 2,
    },
   
    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: (width / 12) * 2,
    },
    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) ,
    },
    {
      field: "trip_start_date",
      headerName: "Start Date",
      width: (width / 12) * 2,
    },
    {
      field: "flag",
      headerName: "All Clear?",
      width: (width / 12),
    },
    {
      field: "pending",
      headerName: "Pending",
      width: (width / 12),
    },
    {
      field: "onhold",
      headerName: "On Hold",
      width: (width / 12),
    },
    {
      field: "diff",
      headerName: "Price Diff.",
      width: (width / 12),
    },
    {
      field: "totalcp",
      headerName: "Total Amount",
      width: (width / 12),
    },
    
    {
      field: "quotesp",
      headerName: "Quote SP",
      width: (width / 12),
    },
    {
      field: "conv_quote",
      headerName: "Conv Quote",
      width: (width / 12),
    },
    
  ];

  const lcolumns = [
    {
      field: "lead_id",
      headerName: " Lead ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: (width / 12) * 1.5,
    },
    {
      field: "lead_destination",
      headerName: "Destination",
      width: (width / 12) ,
    },
    // {
    //   field: "phone_number",
    //   headerName: "Mobile",
    //   width: (width / 12) * 1.5,
    // },
    {
      field: "dup_number",
      headerName: "Dup",
      width: (width / 12) * 1.5,
    },
    {
      field: "timetocreation",
      headerName: "Time Gap",
      width: (width / 12)*0.75 ,
    },
    {
      field: "timetoassign",
      headerName: "Assign Gap",
      width: (width / 12)*0.75,
    },
    {
      field: "lead_travel_date",
      headerName: "Travel Date",
      width: (width / 12) ,
    },
    {
      field: "lead_platform",
      headerName: "Platform",
      width: (width / 12) ,
    },
    {
      field: "lead_owner",
      headerName: "Lead Owner",
      width: (width / 12) ,
    },
    {
      field: "lead_quality",
      headerName: "Quality",
      width: (width / 12) ,
    },
    {
      field: "pax",
      headerName: "Pax",
      width: (width / 12) ,
    },
  ];
  const lcolumns2 = [
    {
      field: "lead_id",
      headerName: " Lead ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: (width / 12) * 1.5,
    },
    {
      field: "lead_destination",
      headerName: "Destination",
      width: (width / 12) ,
    },
    {
      field: "work_done",
      headerName: "Work Done",
      width: (width / 12) * 1,
    },
    {
      field: "dup_number",
      headerName: "Dup",
      width: (width / 12) * 1.5,
    },
    {
      field: "timetocreation",
      headerName: "Time Gap",
      width: (width / 12)*0.75 ,
    },
    {
      field: "timetoassign",
      headerName: "Assign Gap",
      width: (width / 12)*0.75,
    },
    {
      field: "lead_travel_date",
      headerName: "Travel Date",
      width: (width / 12) ,
    },
    {
      field: "lead_platform",
      headerName: "Platform",
      width: (width / 12) ,
    },
    {
      field: "lead_owner",
      headerName: "Lead Owner",
      width: (width / 12) ,
    },
    {
      field: "pax",
      headerName: "Pax",
      width: (width / 12) ,
    },
  ];
  const pscolumns = [
    {
      field: "trip_id",
      headerName: "Trip ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Name",
      width: width / 12,
    },
    {
      field: "trip_start_date",
      headerName: " Start Date",
      width: width / 12,
    },
    {
      field: "destination",
      headerName: "Destination",
      width: width / 12,
    },
    {
      field: "flight_ticket",
      headerName: " Flight Ticket",
      width: width / 12,
    },
    {
      field: "hotel_voucher",
      headerName: "Hotel Voucher",
      width: width / 12,
    },
    {
      field: "land_voucher",
      headerName: "Land Voucher",
      width: width / 12,
    },

    {
      field: "visa",
      headerName: "Visa",
      width: width / 12,
    },
    {
      field: "check_in",
      headerName: "Check-in",
      width: width / 12,
    },
    {
      field: "driver_number",
      headerName: "Driver Number",
      width: width / 12,
    },
    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: width / 12,
    },
    {
      field: "post_sales_notes",
      headerName: "Post Sales Notes",
      width: width / 12,
    },
  ];
  const canccolumns = [
    {
      field: "trip_id",
      headerName: " Trip ID",
      width: width / 12*2,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: width / 12*3,
    },
   
    {
      field: "quality",
      headerName: "Quality",
      width: width / 12,
    },
    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12,
    },
    {
      field: "dest",
      headerName: "Destination",
      width: width / 12,
    },
    {
      field: "last_updated_date",
      headerName: "Last Updated",
      width: width / 12*1,
    },
    {
      field: "last_comment",
      headerName: "Last Comment",
      width: width / 12*3,
    },
    
  ];
  const canccolumns2 = [
    {
      field: "trip_id",
      headerName: " Trip ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: width / 12,
    },
   
    {
      field: "quality",
      headerName: "Quality",
      width: width / 12,
    },
    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12,
    },
    {
      field: "dest",
      headerName: "Destination",
      width: width / 12,
    },
    
   
    {
      field: "canc_flag",
      headerName: "CFlag",
      width: width / 12*1,
    },
    {
      field: "canc_flag_time",
      headerName: "CFlag Time",
      width: width / 12*1,
    },
    {
      field: "past_status",
      headerName: "Last Status",
      width: width / 12*1,
    },
    {
      field: "canc_reason",
      headerName: "Reason",
      width: width / 12*3,
    },
    {
      field: "last_comment",
      headerName: "Last Comment",
      width: width / 12*3,
    },
  ];
  const canccolumns3 = [
    {
      field: "trip_id",
      headerName: " Trip ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: width / 12,
    },
    {
      field: "trip_status",
      headerName: "Trip Status",
      width: width / 12,
    },
    // {
    //   field: "quality",
    //   headerName: "Quality",
    //   width: width / 12,
    // },
    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12,
    },
    {
      field: "dest",
      headerName: "Destination",
      width: width / 12,
    },
    {
      field: "reactivate",
      headerName: "Reactivate",
      width: width / 12,
    },
    {
      field: "prev_comment",
      headerName: "Prev Comment",
      width: width / 12*2,
    },
   
    {
      field: "last_comment",
      headerName: "Last Comment",
      width: width / 12*2,
    },
    {
      field: "canc_reason",
      headerName: "Reason",
      width: width / 12*3,
    },
    {
      field: "canc_flag",
      headerName: "CFlag",
      width: width / 12*1,
    },
    {
      field: "canc_flag_time",
      headerName: "CFlag Time",
      width: width / 12*2,
    },
    {
      field: "past_status",
      headerName: "Last Status",
      width: width / 12*1,
    },
  ];
  const ocolumns = [
    { field: 'trip_id', 
    headerName: ' Trip ID', 
    width: width/12,
    cellClassName: "gridcell"
    //align:"center",
    //headerAlign:"center"
  },
    {
      field: 'cust_name',
      headerName: 'Name',
      width: width/12,
      
    },
    {
      field: 'primary_destination',
      headerName: 'Primary Destination',
      width: width/12,
    },
    {
      field: 'fup_date',
      headerName: 'Fup date',
      width: width/12,
    },
    {
      field: 'ops_owner',
      headerName: 'Ops Owner',
      width: width/12,
    },
    {
      field: 'trip_start_date',
      headerName: 'Trip Start Date',
      width: width/12,
    },
    {
      field: 'flight',
      headerName: 'Flight',
      width: width/12*1,
    },
    {
      field: 'hotel',
      headerName: 'Hotel',
      width: width/12*1,
    },
    {
      field: 'land',
      headerName: 'Land',
      width: width/12*1,
    },
    {
      field: 'visa',
      headerName: 'Visa',
      width: width/12,
    },
    {
      field: 'insurance',
      headerName: 'Insurance',
      width: width/12,
    },
    {
      field: 'others',
      headerName: 'Others',
      width: width/12,
    },
    {
      field: 'vm',
      headerName: 'VM',
      width: width/12,
    },
    {
      field: 'refund',
      headerName: 'Refund',
      width: width/12,
    },
    {
      field: 'trip_owner',
      headerName: 'Trip Owner',
      width: width/12,
    },
    {
      field: 'notes',
      headerName: 'Notes',
      width: width/12,
    },
    {
      field: 'conv_date',
      headerName: 'Conv date',
      width: width/12,
    },
    
  ];
  const sdcolumns = [
    {
      field: "trip_id",
      headerName: " Trip ID",
      width: width / 12*2,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: width / 12*3,
    },
    {
      field: "trip_status",
      headerName: "Trip Status",
      width: width / 12*3,
    },
    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12*2,
    },
    {
      field: "trip_start_date",
      headerName: "Start Date",
      width: width / 12*1,
    },
    {
      field: "primary_destination",
      headerName: "Destination",
      width: width / 12*1,
    },
  ];
  const tcolumns = [
    {
      field: "task_id",
      headerName: " Task ID",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "task_description",
      headerName: "Description",
      width: width / 12*4,
    },
    {
      field: "created_at",
      headerName: "Created",
      width: width / 12*1,
    },
    {
      field: "task_status",
      headerName: "Task Status",
      width: width / 12,
    },
    {
      field: "task_priority",
      headerName: "Task Priority",
      width: width / 12*1,
    },
  
    {
      field: "assigned_by",
      headerName: "Assigned By",
      width: width / 12*1,
    },
    {
      field: "assigned_to",
      headerName: "Assigned To",
      width: width / 12*1,
    },
  ];
  const tcolumns2 = [
    {
      field: "trip_id",
      headerName: " Trip ID",
      width: width / 12*2,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: " Cust Name",
      width: width / 12*3,
    },
    {
      field: 'ops_owner',
      headerName: 'Ops Owner',
      width: width/12,
    },
    {
      field: 'trip_start_date',
      headerName: 'Trip Start Date',
      width: width/12,
    },
    {
      field: 'primary_destination',
      headerName: 'Primary Destination',
      width: width/12,
    },
    {
      field: 'transfer_state',
      headerName: 'Transfer State',
      width: width/12,
    },
    {
      field: 'on_hold',
      headerName: 'On Hold',
      width: width/12,
    },
  ];

  const convcolumns = [
    {
      field: "trip_id",
      headerName: "Trip ID",
      width: width / 12,
      cellClassName: "gridcell",
    },
    {
      field: "cust_name",
      headerName: "Name",
      width: width / 12,
    },
    {
      field: "trip_start_date",
      headerName: "Start Date",
      width: width / 12,
    },
    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12,
    },
    {
      field: "transfer_state",
      headerName: "Transfer State",
      width: width / 12,
    },
    {
      field: "ops_assigned",
      headerName: "Ops Assigned",
      width: width / 12,
    },
    {
      field: "conv_date",
      headerName: "Conv Date",
      width: width / 12*2,
    },
    {
      field: "profit",
      headerName: "Profit",
      width: width / 12,
    },
    
  ];

  const qcolumns = [
    {
      field: "quote_id",
      headerName: " Quote Id",
      width: (width / 24),
      cellClassName: "gridcell",
    },
    {
      field: "trip_id",
      headerName: "Trip Id",
      width: (width / 24),
    },
    {
      field: "cust_name",
      headerName: "Cust Name",
      width: (width / 12),
    },
    {
      field: "destination",
      headerName: "Destination",
      width: (width / 12),
    },
    {
      field: "status",
      headerName: "Status",
      width: (width / 12),
    },
    {
      field: "note",
      headerName: "Note",
      width: (width / 12)*2,
    },
    {
      field: "flight_sp",
      headerName: "Flight Total",
      width: (width / 12)*0.75,
    },
    {
      field: "flight_pp",
      headerName: "Flight PP",
      width: (width / 12)*0.75,
    },
    {
      field: "flight_profit",
      headerName: "Flight Profit",
      width: (width / 12),
    },
    {
      field: "land_sp",
      headerName: "Land SP",
      width: (width / 12)*0.75,
    },
    {
      field: "land_pp",
      headerName: "Land PP",
      width: (width / 12)*0.75,
    },
    
    {
      field: "flight_profit",
      headerName: "Flight Profit",
      width: (width / 12),
    },
    {
      field: "land_profit",
      headerName: "Land Profit",
      width: (width / 12),
    },
    {
      field: "land_profit_perc",
      headerName: "Land Profit %",
      width: (width / 12),
    },
    {
      field: "budget",
      headerName: "Budget",
      width: (width / 12),
    },
    {
      field: "type",
      headerName: "Type",
      width: (width / 12),
    },
    {
      field: "special",
      headerName: "Special",
      width: (width / 12),
    },
    {
      field: "created_at",
      headerName: "Created At",
      width: (width / 12),
    },
  ];

  const qcolumns2 = [
    {
      field: "quote_id",
      headerName: " Quote Id",
      width: (width / 24),
      cellClassName: "gridcell",
    },
    {
      field: "trip_id",
      headerName: "Trip Id",
      width: (width / 24),
    },
    {
      field: "cust_name",
      headerName: "Cust Name",
      width: (width / 12),
    },
    {
      field: "destination",
      headerName: "Destination",
      width: (width / 12),
    },
    {
      field: "status",
      headerName: "Status",
      width: (width / 12),
    },
    {
      field: "note",
      headerName: "Note",
      width: (width / 12)*2,
    },
    {
      field: "flight_sp",
      headerName: "Flight Total",
      width: (width / 12)*0.75,
    },
    {
      field: "flight_pp",
      headerName: "Flight PP",
      width: (width / 12)*0.75,
    },
    {
      field: "flight_profit",
      headerName: "Flight Profit",
      width: (width / 12),
    },
    {
      field: "land_sp",
      headerName: "Land SP",
      width: (width / 12)*0.75,
    },
    {
      field: "land_pp",
      headerName: "Land PP",
      width: (width / 12)*0.75,
    },
    
    {
      field: "flight_profit",
      headerName: "Flight Profit",
      width: (width / 12),
    },
    {
      field: "land_profit",
      headerName: "Land Profit",
      width: (width / 12),
    },
    {
      field: "land_profit_perc",
      headerName: "Land Profit %",
      width: (width / 12),
    },
    {
      field: "budget",
      headerName: "Budget",
      width: (width / 12),
    },
    {
      field: "type",
      headerName: "Type",
      width: (width / 12),
    },
    {
      field: "special",
      headerName: "Special",
      width: (width / 12),
    },
    {
      field: "edited_at",
      headerName: "Edited At",
      width: (width / 12),
    },
  ];

  const fupcolumns = [
   
    {
      field: "trip_id",
      headerName: "Trip Id",
      width: (width / 12),
    },
    {
      field: "trip_owner",
      headerName: "Owner",
      width: (width / 12),
    },
    {
      field: "status",
      headerName: "Fup Status",
      width: (width / 12),
    },
    {
      field: "note",
      headerName: "Fup Note",
      width: (width / 12)*2,
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: (width / 12),
    },
   
    {
      field: "fup_by",
      headerName: "FUP By",
      width: (width / 12)*2,
    },
    {
      field: "called_today",
      headerName: "Called",
      width: (width / 12),
    },
   
    {
      field: "called_by",
      headerName: "Caller",
      width: (width / 12),
    },
    {
      field: "skip_reason",
      headerName: "Skip Reason",
      width: (width / 12),
    },
    
     {
      field: "called_time",
      headerName: "Called At",
      width: (width / 12)*2,
    },
     {
      field: "fup_time",
      headerName: "Time",
      width: (width / 12)*2,
    },
    
  ];

  const fupheaders=[
     {label:"Owner", key:"trip_owner"},
    {label:"Trip Id", key:"trip_id"},
    {label:"FUP Status", key:"status"},
    {label:"Note", key:"note"},
    {label:"FUP time", key:"fup_time"},
    {label:"FUP By", key:"fup_by"},
    {label:"Called Today?", key:"called_today"},
    {label:"Call Time", key:"called_time"},
    {label:"Called By", key:"called_by"},
    {label:"Skip Reason", key:"skip_reason"},
    {label:"Created", key:"createdAt"},
  ]

  const duecolumns=[
    
    {
      field: "trip_id",
      headerName: "Trip Id",
      width: (width / 24),
      cellClassName: "gridcell",
    },
    {
      field: "cust_name",
      headerName: "Cust Name",
      width: (width / 12),
    },
    {
      field: "name",
      headerName: "Name",
      width: (width / 12),
    },
    {
      field: "amount",
      headerName: "Amount",
      width: (width / 12),
    },
    {
      field: "status",
      headerName: "Status",
      width: (width / 12),
    },
  ]

  const cancheaders=[
    {label:"Owner", key:"trip_owner"},
    {label:"Name", key:"cust_name"},
    {label:"Trip Id", key:"trip_id"},
    {label:"Trip Status", key:"trip_status"},
    {label:"Canc Flag", key:"canc_flag"},
    {label:"Last Updated", key:"last_updated_date"},
    {label:"Dest", key:"dest"},
    {label:"Quality", key:"quality"},
    {label:"Canc Flag Time", key:"canc_flag_time"},
    {label:"Past Status", key:"past_status"},
    {label:"Canc Reason", key:"canc_reason"},
     
  ]
  const [copon, setcopon] = useState(true);
  const [isOwner, setisOwner] = useState(true);
  const [show0000, setshow0000] = useState(true);
  const [showlq, setshowlq] = useState(false);
  const [tdfup, settdfup] = useState(true);
  const [funnel, setfunnel] = useState([]);
  const [opencust, setopencust] = useState([]);
  const [expanded1, setexpanded1] = useState(false);
  const [expanded2, setexpanded2] = useState(false);
  const [expanded3, setexpanded3] = useState(false);
  const [expanded4, setexpanded4] = useState(false);
  const [expanded5, setexpanded5] = useState(false);
  const [expanded6, setexpanded6] = useState(false);
  const [expanded7, setexpanded7] = useState(false);
  const [expanded8, setexpanded8] = useState(false);
  const [expanded9, setexpanded9] = useState(false);
  const [expanded10, setexpanded10] = useState(false);
  const [expanded11, setexpanded11] = useState(false);
  const [expanded12, setexpanded12] = useState(false);
  const [expanded13, setexpanded13] = useState(false);
  const [expanded14, setexpanded14] = useState(false);
  const [expanded15, setexpanded15] = useState(false);
  const [expanded16, setexpanded16] = useState(false);
  const [expanded17, setexpanded17] = useState(false);
  const [expanded27, setexpanded27] = useState(false);
  const [showall, setshowall] = useState(true);
  //var { cuser, role } = GetRole();
  const { cuser, role, employeelist, destinationlist, loading } = GetRole();
  const [emp, setemp]=useState([])
  const [salesemp, setsalesemp]=useState([])
  const [opsemp, setopsemp]=useState([])
  const [dest, setdest]=useState([])
  const [dest2, setdest2]=useState([])
  const [fupcheckdata, setfupcheckdata]=useState([])
  const [filterData, setfilterData]=useState({})
  const [filterData2, setfilterData2]=useState({})
  const [filterData3, setfilterData3]=useState({})
  const [filterData7, setfilterData7]=useState({})
  const [leadfilterData, setleadfilterData]=useState({})
  const [opsfilterData, setopsfilterData]=useState({})
  const [followupData, setfollowupData] = useState([]);
  const [allfollowupData, setallfollowupData] = useState([]);
  const [callmissedData, setcallmissedData] = useState([]);
  const [paymentData, setpaymentData] = useState([]);
  const [paymentData2, setpaymentData2] = useState([]);
  const [listtripconvData2, setlisttripconvData2] = useState([]);
  const [leadlistData, setleadlistData] = useState([]);
  const [dupData, setdupData] = useState([]);
  const [custData, setcustData] = useState([]);
  const [cancData, setcancData] = useState([]);
  const [cancData2, setcancData2] = useState([]);
  const [leadData, setleadData] = useState([]);
  const [leadData2, setleadData2] = useState([]);
  const [taskData, settaskData] = useState([]);
  const [quoteData, setquoteData] = useState([]);
  const [selection, setselection] = useState([]);
  const [selection2, setselection2] = useState([]);
  const [selection3, setselection3] = useState([]);
  const [sdtrips, setsdtrips] = useState([]);
  const [dialog1, setdialog1] = useState(false);
  const [resultobject, setresultobject] = useState({});
  const [resultobject2, setresultobject2] = useState({});
  const [resultobject3, setresultobject3] = useState({});
  const [resultobject4, setresultobject4] = useState({});
  const [resultobject5, setresultobject5] = useState({});
  const [resultobject6, setresultobject6] = useState({});
  const [resultobject7, setresultobject7] = useState({});
  const [resultobject8, setresultobject8] = useState({});
  const [resultobjectothers, setresultobjectothers] = useState({});
  const [sumlead1, setsumlead1] = useState({});
  const [sumlead2, setsumlead2] = useState({});
  const [sumlead3, setsumlead3] = useState({});
  const [sumlead4, setsumlead4] = useState({});
  const [sumlead5, setsumlead5] = useState({});
  const [sumlead6, setsumlead6] = useState({});
  const [sumlead7, setsumlead7] = useState({});
  const [sumlead8, setsumlead8] = useState({});
  const [sumleadothers, setsumleadothers] = useState({});
  const [qpData, setqpData] = useState([]);
  const [leadselectionData, setleadselectionData] = useState([]);
  const [custselectionData, setcustselectionData] = useState([]);
  const [listquoteData2, setlistquoteData2] = useState([]);
  const [listquoteData3, setlistquoteData3] = useState([]);
  const [defaultleadData, setdefaultleadData] = useState(true);
  const [Open, setOpen] = useState(false);
  const [Open2, setOpen2] = useState(false);
  const [leadallocation, setleadallocation] = useState(false);

  const todayDate = DateCalc(0);
  const yesterday = DateCalc(-1)
  const dby=DateCalc(-2)
  const nextDate = DateCalc(1);

  const d=new Date()
  d.setHours(12,0,0)

  const c=new Date()
  c.setHours(18,0,0)

  const getFollowups = async (id) => {
    try{
    if(role=="Admin" || role=="Manager" || role=="TL" || role=="Operations" || role=="Operations-TL" || role=="Product"  || role=="Sales Support"){
    if(leadfilterData.trip_owner && leadfilterData.trip_status){
      const data = await fetchTripsbyStatusandOwner(leadfilterData.trip_status,leadfilterData.trip_owner);
      const temp=data.data.filter(t=>t.trip_status !=="Postponed")
      setfollowupData(temp);
      l1=temp
    }else if(leadfilterData.trip_owner){
      const data = await fetchActiveTripsbyTripOwner(leadfilterData.trip_owner);
      const temp=data.data.filter(t=>t.trip_status !=="Postponed")
      setfollowupData(temp);
      l1=temp
    } else if(leadfilterData.trip_status){
      const data = await fetchTripsbyStatus(leadfilterData.trip_status);
      const temp=data.data.filter(t=>t.trip_status !=="Postponed")
      setfollowupData(temp);
      
    }else{
      const data = await fetchActiveTrips();
      const temp=data.data.filter(t=>t.trip_status !=="Postponed")
      setfollowupData(temp);
      
      //l1=data.data.filter(tripdata => tripdata.trip_status !== "Converted")
    }
 
    
  }
    //console.log(data2.data)
  // } else if (role=="TL"){
  //   if(leadfilterData.trip_owner && leadfilterData.trip_status){
  //     const data = await fetchTripsbyStatusandOwner(leadfilterData.trip_status,leadfilterData.trip_owner);
  //     setfollowupData(data.data);
  //     l1=data.data
  //   }else if(leadfilterData.trip_owner){
  //     const data = await fetchActiveTripsbyTripOwner(leadfilterData.trip_owner);
  //     setfollowupData(data.data);
  //     l1=data.data
  //   } else if(leadfilterData.trip_status){
  //     const data = await fetchTripsbyStatusTL(leadfilterData.trip_status, cuser);
  //     //const data = await fetchActiveTrips();
  //     setfollowupData(data.data);
  //   }else{
  //     const data = await fetchActiveTripsbyTL(cuser);
  //     setfollowupData(data.data);
  //     //l1=data.data.filter(tripdata => tripdata.trip_status !== "Converted")
  //   }
  //   const data2 = await fetchConvertedTripsbyTL(cuser);
  //   setpaymentData(data2.data);
  // }
}catch(err){
  console.log(err)
}
  };

  const getFollowups2 = async (id) => {
    try{

       const data = await fetchRules();
                //console.log(data.data)
                const data2=await todaysignin()
                //console.log(data2.data)
                var emaillist=data2.data.map(d=>d.user)
                var saleslist=employeelist.filter(e=>e.role=="Sales" && emaillist.includes(e.email))
                var salesusers=saleslist.map(s=>s.short_name)
                console.log(salesusers)
                const availablesp=data.data[0].leadrule.filter(lr=>salesusers.includes(lr.name) && lr.availability=="Yes")
                
                var spnames=availablesp.map(s=>s.name)
                console.log(spnames)
    if(role=="Admin" || role=="Manager" || role=="TL" || role=="Operations" || role=="Operations-TL" || role=="Product"  || role=="Sales Support"){
    if(leadfilterData.trip_owner && leadfilterData.trip_status){
      const data = await fetchTripsbyStatusandOwner(leadfilterData.trip_status,leadfilterData.trip_owner);
      const temp=data.data.filter(t=>t.trip_status !=="Postponed" && salesusers.includes(t.trip_owner))
      setfollowupData(temp);
      l1=temp
    }else if(leadfilterData.trip_owner){
      const data = await fetchActiveTripsbyTripOwner(leadfilterData.trip_owner);
      const temp=data.data.filter(t=>t.trip_status !=="Postponed" && salesusers.includes(t.trip_owner))
      setfollowupData(temp);
      l1=temp
    } else if(leadfilterData.trip_status){
      const data = await fetchTripsbyStatus(leadfilterData.trip_status);
      const temp=data.data.filter(t=>t.trip_status !=="Postponed" && salesusers.includes(t.trip_owner))
      setfollowupData(temp);
      
    }else{
      const data = await fetchActiveTrips();
      const temp=data.data.filter(t=>t.trip_status !=="Postponed" && salesusers.includes(t.trip_owner))
      setfollowupData(temp);
      
      //l1=data.data.filter(tripdata => tripdata.trip_status !== "Converted")
    }
 
    
  }
    //console.log(data2.data)
  // } else if (role=="TL"){
  //   if(leadfilterData.trip_owner && leadfilterData.trip_status){
  //     const data = await fetchTripsbyStatusandOwner(leadfilterData.trip_status,leadfilterData.trip_owner);
  //     setfollowupData(data.data);
  //     l1=data.data
  //   }else if(leadfilterData.trip_owner){
  //     const data = await fetchActiveTripsbyTripOwner(leadfilterData.trip_owner);
  //     setfollowupData(data.data);
  //     l1=data.data
  //   } else if(leadfilterData.trip_status){
  //     const data = await fetchTripsbyStatusTL(leadfilterData.trip_status, cuser);
  //     //const data = await fetchActiveTrips();
  //     setfollowupData(data.data);
  //   }else{
  //     const data = await fetchActiveTripsbyTL(cuser);
  //     setfollowupData(data.data);
  //     //l1=data.data.filter(tripdata => tripdata.trip_status !== "Converted")
  //   }
  //   const data2 = await fetchConvertedTripsbyTL(cuser);
  //   setpaymentData(data2.data);
  // }
}catch(err){
  console.log(err)
}
  };

  const getFollowupbyTripOwner = async (owner, id) => {
    try{
    //console.log("owner")
    const data = await fetchActiveTripsbyTripOwner(owner);
    const temp2=data.data.filter(t=>t.trip_status !=="Postponed")
    setfollowupData(temp2);
    const leadfuptoday = temp2.filter(
      (trip) =>
      trip.trip_status !=="Converted" &&
      
        trip.follow_up &&
        trip.follow_up[trip.follow_up.length - 1]?.time !== "00:00" &&
        trip.follow_up.length > 0 &&
        (new Date(trip.follow_up[trip.follow_up.length - 1]?.createdAt).getTime() >=
          new Date(todayDate).getTime() &&
          new Date(trip.follow_up[trip.follow_up.length - 1]?.createdAt).getTime() <=
          new Date(nextDate).getTime()) ||
          (new Date(trip.follow_up[trip.follow_up.length - 2]?.createdAt).getTime() >=
            new Date(todayDate).getTime() &&
            new Date(trip.follow_up[trip.follow_up.length - 2]?.createdAt).getTime() <=
            new Date(nextDate).getTime()) ||
            (new Date(trip.follow_up[trip.follow_up.length - 3]?.createdAt).getTime() >=
              new Date(todayDate).getTime() &&
              new Date(trip.follow_up[trip.follow_up.length - 3]?.createdAt).getTime() <=
              new Date(nextDate).getTime()) ||
              (new Date(trip.follow_up[trip.follow_up.length - 4]?.createdAt).getTime() >=
                new Date(todayDate).getTime() &&
                new Date(trip.follow_up[trip.follow_up.length - 4]?.createdAt).getTime() <=
                new Date(nextDate).getTime()) 
    );
    const leadfuptoday2=leadfuptoday.filter(data => data.trip_status !=="Converted" && (new Date(data.createdAt).getTime()<new Date(todayDate).getTime()))
    setcallmissedData(leadfuptoday2)
    const temp=data.data.filter(tripdata => tripdata.quote_pending)
    setqpData(temp)
    const data2 = await fetchConvertedTripsbyTripOwner(owner);
    const tempx=data2.data.filter(trip=>!("on_hold" in trip && trip.on_hold))
    setpaymentData(tempx);
    //console.log(data2.data)
  }catch(err){
    console.log(err)
  }
  };
  //console.log(cuser,role)
  const getLead = async (owner) => {
    try{
      console.log("There")
    let tripdata=[]
    const data = await fetchLeads(owner);
    // if(cuser=="Aakansha"){
    //   setleadData(data.data.filter(l=>new Date(l.createdAt).getTime() !==new Date(l.assignedAt).getTime()));
    // }else{
    //   setleadData(data.data);
    // }
    setleadData(data.data);
    for (let i=0;i<data.data.length;i++){
      const data2=await fetchdupTripsbyNumber(data.data[i].mobile_number)
      if(data2.data && data2.data.length>0){
        tripdata=[...tripdata, data2.data[data2.data.length-1]]
      }
    }
    console.log(tripdata)
    setdupData(tripdata)
  }catch(err){
    console.log(err)
  }
    //console.log(data2.data)
  };

  const getTasksbyOwner = async (owner) => {
    try{
    //console.log(cuser)
    const data = await fetchTasksbyOwner(owner);
    //console.log(data.data)
    if(Array.isArray(data.data) && data.data.length > 0) {
      //console.log("array")
      settaskData(data.data);
    }
    if(typeof data.data === 'object' && data.data !== null && "deadline_date" in data.data){
      //console.log("object")
      settaskData([data.data]);
    }
  }catch(err){
    console.log(err)
  }
  };

  const getTasks = async () => {
    try{
    const data = await fetchopentasks();
    if(data.data.length > 0) {
       const temp=data.data.filter(t=>t.task_status!=="Close" && !("private_task" in t && t.private_task))
      settaskData(temp);
    }
  }catch(err){
    console.log(err)
  }
  };

  const postTCLead = async (hr,mn) => {
    try{
    //console.log("owner")
    const addTCLeadsResponse = await addTCLeads(hr,mn);
    if(addTCLeadsResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
      //alert(addTCLeadsResponse.data.length+" TC leads added successfully. Leads uploaded since : "+hr+":"+mn);
      console.log(addTCLeadsResponse)
      
  }
  else{
      alert("Something went wrong. Contact support");
      window.location = ("/");
  }
    //console.log(data.data);
  }catch(err){
    console.log(err)
  }
    //console.log(data2.data)
  };

  const getLeadbyLeadOwner = async (owner) => {
    try{
     console.log(owner)
      let tripdata=[]
    const data = await fetchLeadsbyTripOwner(owner);
    // if(cuser=="Aakansha"){
    //   setleadData(data.data.filter(l=>new Date(l.createdAt).getTime() !==new Date(l.assignedAt).getTime()));
    // }else{
      setleadData(data.data);
      console.log(data.data)
    
    for (let i=0;i<data.data.length;i++){
      const data2=await fetchTripsbyNumber(data.data[i].mobile_number)
      //console.log(data2.data)
      if(data2.data && data2.data.length>0){
        tripdata=[...tripdata, data2.data[data2.data.length-1]]
      }
    }
    //console.log(tripdata)
    setdupData(tripdata)
  }catch(err){
    console.log(err)
  }
    //console.log(data2.data)
  };

  const getCust = async () => {
    try{
    //console.log("owner")
    const data = await fetchOpenCustomers();
    setcustData(data.data);
    const temp=data.data.map(c=>c.primary_mobile_number)
    const leadlist=await fetchleadsbynumber2(temp)
    console.log(leadlist.data)
    setleadlistData(leadlist.data)
  }catch(err){
    console.log(err)
  }
    //console.log(data2.data)
  };

  const getCustbyOwner = async (owner) => {
    try{
    //console.log("owner")
    const data = await fetchCustomersbyOwner(owner);
    setcustData(data.data);
  }catch(err){
    console.log(err)
  }
    //console.log(data2.data)
  };

  const getCanc = async (cancdate) => {
    try{
    //console.log("owner")
    const data = await fetchCanc(cancdate);
    setcancData(data.data);
 
    console.log(data.data)
  }catch(err){
    console.log(err)
  }
  };

  const getCancbyOwner = async (owner, cancdate) => {
    try{
    //console.log("owner")
    const data = await fetchCancbyOwner(owner, cancdate);
    setcancData(data.data);
   
    //console.log(data.data)
  }catch(err){
    console.log(err)
  }
  };

  const getEmployees = async () => {
    try{
    // const data = await fetchEmployees();
   
    const empsplist2 = employeelist.filter((emp) => emp.role == "Operations" || emp.role=="TL");
    const empsplist = employeelist.filter((emp) => emp.role == "Sales" || emp.role=="TL" || emp.role == "SME");
    // let nameArr = (empsplist2).map(({ short_name, doj }) => {
    //   return {'short_name': short_name, 'doj': doj}
    // });
    const empsplist3 = employeelist.filter((emp) => emp.role == "Sales");
    const empshortname = empsplist.map((emp) => emp.short_name);
    let sortedemp = empshortname.sort()
    setemp(sortedemp);
    const empshortname2 = empsplist2.map((emp) => emp.short_name);
    setopsemp(empshortname2)
    const empshortname3 = empsplist3.map((emp) => emp.short_name);
    let sortedemp3 = empshortname3.sort()
    setsalesemp(sortedemp3);
  }catch(err){
    console.log(err)
  }
  };

  const getEmployeesbyTL = async () => {
    try{
    const data = await fetchTeambyName(cuser);
    //const custdatalistfromdb= data.data

    //const empsplist = data.data.filter((emp) => emp.role == "Sales");
    const empshortname = data.data.map((emp) => emp.short_name);
    let sortedemp = empshortname.sort()
    setemp(sortedemp);
    //setemp(empshortname);
  }catch(err){
    console.log(err)
  }
  };

  const getDest = async () => {
    try{
    // const data = await fetchDest();
    //const temp=destinationlist.filter(d=>"order" in d)
    setdest(destinationlist);
    setdest2([...destinationlist, "Bali", "Abu Dhabi"])
  }catch(err){
    console.log(err)
  }
  }

const getTripsbyTripOwner = async (owner) => {
  try{
  console.log(owner)
  const data = await fetchConvertedTripsbyTripOwner(owner);
  setlisttripconvData2(data.data)
}catch(err){
  console.log(err)
}
  //console.log(followupData)
}

const getTripsbyTL = async (owner) => {
  try{
  //console.log(owner)
  const data = await fetchConvertedTripsbyTL(owner);
  setlisttripconvData2(data.data)
}catch(err){
  console.log(err)
}
  //console.log(followupData)
}

const getCancbyTL = async (owner, cancdate) => {
  try{
  //console.log("owner")
  const data = await fetchCancbyTL(owner, cancdate);
  setcancData(data.data);
}catch(err){
  console.log(err)
}
  //console.log(data.data)
};

const getLeadbyTL = async (owner) => {
  try{
  //console.log("owner")
  const data = await fetchLeadsbyTL(owner);
  setleadData(data.data);

  console.log(data.data)
}catch(err){
  console.log(err)
}
};

const getleadtodaybyowner = async (owner) => {
  setdefaultleadData(false)
  try{
    let tripdata=[]
  const data=await fetchLeadsTodaybyTripOwner(owner)
  var temp=[]
  temp=data.data.sort((a,b)=> new Date(a.assignedAt).getTime() - new Date(b.assignedAt).getTime()).reverse()

  console.log(temp)
  setleadData2(temp);
  for (let i=0;i<data.data.length;i++){
      const data2=await fetchdupTripsbyNumber(data.data[i].mobile_number)
      if(data2.data && data2.data.length>0){
        tripdata=[...tripdata, data2.data[data2.data.length-1]]
      }
    }
    //console.log(tripdata)
    setdupData(tripdata)

}catch(err){
  console.log(err)
}
}

const loadpayment=async() =>{
  try{
  const data2 = await fetchConvertedTripsOnly();
  setpaymentData(data2.data);
  
}catch(err){
  console.log(err)
}
}

const loadpayment2=async() =>{
  try{
  const data2 = await fetchConvertedTripsOnly();
  var temp2=[]
 
  const fifteen=DateCalc(15)
  const temp=data2.data.filter(trip=>new Date(trip.trip_start_date).getTime()<new Date(fifteen).getTime())
  setpaymentData2(temp);
  const temp3=data2.data.filter(trip=>new Date(trip.trip_start_date).getTime()>new Date().getTime() && new Date(trip.trip_start_date).getTime()<new Date(fifteen).getTime())
  const temp4=temp3.map(t=>t.conv_quote)
  const data3=await fetchQuotebyIdGroup(temp4)
  console.log(data3.data)
  for (let i=0;i<temp3.length;i++){
    //console.log(i)
    //console.log(data2.data[i])
    if(temp3[i].conv_quote && temp3[i].conv_quote!==1){
      const data=await fetchQuotebyId(temp3[i].conv_quote)
      //console.log(data.data)
      temp2=[...temp2,data.data] 
      //console.log(temp2)
     }
  }
  setquoteData(temp2)
}catch(err){
  console.log(err)
}
}

const futuretripsonly=()=>{
  const temp=paymentData2.filter(trip=>new Date(trip.trip_start_date).getTime()>new Date().getTime())
  setpaymentData2(temp);
}


const showleadbreakup=()=>{
  let tempresultobject={}
  let tempresultobject2={}
  let tempresultobject3={}
  let tempresultobject4={}
  let tempresultobject5={}
  let tempresultobject6={}
  let tempresultobject7={}
  let tempresultobject8={}
  let tempresultobjectothers={}
  var sum1=0, sum2=0, sum3=0, sum4=0, sum5=0, sum6=0, sum7=0, sum8=0, temp=[], sumothers=0
  // if(copon){ 
    temp=leaddatalistdisplay.filter(lead=>newgetqualitylead(lead)!=="Iron" && newgetqualitylead(lead)!=="Copper" && newgetqualitylead(lead)!=="Silver");
 
 
  const tl1=temp.filter(lead=>lead.lead_owner=="Hitesh")
  const tl2=temp.filter(lead=>lead.lead_owner=="Sidharth")
  const tl3=temp.filter(lead=>lead.lead_owner=="Yadvinder")
  const tl4=temp.filter(lead=>lead.lead_owner=="Tarun")
  const tl5=temp.filter(lead=>lead.lead_owner=="Tulsi")
  const tl6=temp.filter(lead=>lead.lead_owner=="NitinK")
  const tl7=temp.filter(lead=>lead.lead_owner=="Manish")
  const tl8=temp.filter(lead=>lead.lead_owner=="Qausain")
  const others=temp.filter(lead=>lead.lead_owner!=="Hitesh" && lead.lead_owner!=="Sidharth" && lead.lead_owner!=="Yadvinder" && lead.lead_owner!=="Tarun" && lead.lead_owner!=="HarshB" && lead.lead_owner!=="NitinK" && lead.lead_owner!=="Rana" && lead.lead_owner!=="Qausain" && lead.lead_owner!=="Tulsi" && lead.lead_owner!=="Manish")

  const result1=groupBy(tl1, v=>v.lead_destination)
  const result2=groupBy(tl2, v=>v.lead_destination)
  const result3=groupBy(tl3, v=>v.lead_destination)
  const result4=groupBy(tl4, v=>v.lead_destination)
  const result5=groupBy(tl5, v=>v.lead_destination)
  const result6=groupBy(tl6, v=>v.lead_destination)
  const result7=groupBy(tl7, v=>v.lead_destination)
  const result8=groupBy(tl8, v=>v.lead_destination)
  const resultothers=groupBy(others, v=>v.lead_destination)

  for (let [key, value] of result1) {
    sum1=sum1+value.length
    tempresultobject[key]=value.length
    }
    for (let [key, value] of result2) {
      sum2=sum2+value.length
      tempresultobject2[key]=value.length
      }
      for (let [key, value] of result3) {
        sum3=sum3+value.length
        tempresultobject3[key]=value.length
        }
        for (let [key, value] of result4) {
          sum4=sum4+value.length
          tempresultobject4[key]=value.length
          }
          for (let [key, value] of result5) {
            sum5=sum5+value.length
            tempresultobject5[key]=value.length
            }
            for (let [key, value] of result6) {
              sum6=sum6+value.length
              tempresultobject6[key]=value.length
              }
              for (let [key, value] of result7) {
                sum7=sum7+value.length
                tempresultobject7[key]=value.length
                }
                for (let [key, value] of result8) {
                sum8=sum8+value.length
                tempresultobject8[key]=value.length
                }
              for (let [key, value] of resultothers) {
                sumothers=sumothers+value.length
                tempresultobjectothers[key]=value.length
                }
        setresultobject(tempresultobject)
        setresultobject2(tempresultobject2)
        setresultobject3(tempresultobject3)
        setresultobject4(tempresultobject4)
        setresultobject5(tempresultobject5)
        setresultobject6(tempresultobject6)
        setresultobject7(tempresultobject7)
        setresultobject8(tempresultobject8)
        setresultobjectothers(tempresultobjectothers)
        setsumlead1(sum1)
        setsumlead2(sum2)
        setsumlead3(sum3)
        setsumlead4(sum4)
        setsumlead5(sum5)
        setsumlead6(sum6)
        setsumlead7(sum7)
        setsumlead8(sum8)
        setsumleadothers(sumothers)
        setdialog1(true)

}

function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach((item) => {
       const key = keyGetter(item);
       const collection = map.get(key);
       if (!collection) {
           map.set(key, [item]);
       } else {
           collection.push(item);
       }
  });
  return map;
}

const getCustbyTL = async (owner) => {
  try{
  //console.log("owner")
  const data = await fetchCustomersbyTL(owner);
  setcustData(data.data);
}catch(err){
  console.log(err)
}
  //console.log(data2.data)
};

const getconvtrips= async ()=>{
  try{
  const data = await fetchConvertedTripsOnly();
  const data2=data.data.filter(trip=> trip.trip_status !=="Dropped After Booking" && !("hold_ops" in trip && trip.hold_ops) && !("booking" in trip && "flight" in trip.booking && trip.booking.flight=="NA" && "hotel" in trip.booking && trip.booking.hotel=="NA" && "land" in trip.booking && trip.booking.land=="NA"));
  setlisttripconvData2(data2)
}catch(err){
  console.log(err)
}
}

const getdupnumber=(number)=>{
  const x=dupData.filter(t=> t.primary_mobile_number ==number)
  if(x && x.length > 0){
    if(role=="Sales" && x[x.length-1].trip_status=="Cancelled"){
          return ""
    }else{
          return x[x.length-1].trip_id+" ("+x[x.length-1].trip_owner+" - "+x[x.length-1].trip_status+")"
    }
  //console.log(x)
 
  }else{
    return ""
  }
}

const getallFollowups=async()=>{
  //console.log(dby, yesterday)
  if(filterData2.trip_owner && filterData2.date){
    const data = await fetchActiveTripsbyTripOwner(filterData2.trip_owner);
    // console.log(data.data)
    // for(let i=0; i<data.data.length; i++){
    //   if(data.data[i].trip_id==32574 || data.data[i].trip_id==32508){
    //   console.log(new Date(data.data[i].createdAt).getTime())
    //   console.log(new Date(todayDate).getTime())
    //   console.log(new Date(data.data[i].createdAt).getTime()-new Date(todayDate).getTime())
    //   console.log(new Date(todayDate).getTime()-new Date(data.data[i].createdAt).getTime())
    //   if(new Date(todayDate).getTime()<=new Date(data.data[i].createdAt).getTime()){
    //     console.log("ABC")
    //   }
    //   if(new Date(data.data[i].createdAt).getTime()<=new Date(todayDate).getTime()){
    //     console.log("DEF")
    //   }
    //   }
    // }
    // console.log(new Date(data.data[0].createdAt).getTime())
    // console.log(new Date(todayDate).getTime())
    const leadfuptoday = data.data.filter(
      (trip) =>
      trip.trip_status !=="Converted" &&
      
        trip.follow_up &&
        trip.follow_up[trip.follow_up.length - 1]?.time !== "00:00" &&
        trip.follow_up.length > 0 &&
        (new Date(trip.follow_up[trip.follow_up.length - 1]?.createdAt).getTime() >=
          new Date(todayDate).getTime() &&
          new Date(trip.follow_up[trip.follow_up.length - 1]?.createdAt).getTime() <=
          new Date(nextDate).getTime()) ||
          (new Date(trip.follow_up[trip.follow_up.length - 2]?.createdAt).getTime() >=
            new Date(todayDate).getTime() &&
            new Date(trip.follow_up[trip.follow_up.length - 2]?.createdAt).getTime() <=
            new Date(nextDate).getTime()) ||
            (new Date(trip.follow_up[trip.follow_up.length - 3]?.createdAt).getTime() >=
              new Date(todayDate).getTime() &&
              new Date(trip.follow_up[trip.follow_up.length - 3]?.createdAt).getTime() <=
              new Date(nextDate).getTime()) ||
              (new Date(trip.follow_up[trip.follow_up.length - 4]?.createdAt).getTime() >=
                new Date(todayDate).getTime() &&
                new Date(trip.follow_up[trip.follow_up.length - 4]?.createdAt).getTime() <=
                new Date(nextDate).getTime()) 
    );
      //console.log(leadfuptoday)
    const leadfupyesterday = data.data.filter(
      (trip) =>
      trip.trip_status !=="Converted" &&
        trip.follow_up &&
        trip.follow_up[trip.follow_up.length - 1]?.time !== "00:00" &&
        
      
        trip.follow_up.length > 0 &&
        (new Date(trip.follow_up[trip.follow_up.length - 1]?.createdAt).getTime() >=
          new Date(yesterday).getTime() &&
          new Date(trip.follow_up[trip.follow_up.length - 1]?.createdAt).getTime() <=
          new Date(todayDate).getTime()) ||
          (new Date(trip.follow_up[trip.follow_up.length - 2]?.createdAt).getTime() >=
          new Date(yesterday).getTime() &&
          new Date(trip.follow_up[trip.follow_up.length - 2]?.createdAt).getTime() <=
          new Date(todayDate).getTime()) ||
          (new Date(trip.follow_up[trip.follow_up.length - 3]?.createdAt).getTime() >=
          new Date(yesterday).getTime() &&
          new Date(trip.follow_up[trip.follow_up.length - 3]?.createdAt).getTime() <=
          new Date(todayDate).getTime()) ||
          (new Date(trip.follow_up[trip.follow_up.length - 4]?.createdAt).getTime() >=
          new Date(yesterday).getTime() &&
          new Date(trip.follow_up[trip.follow_up.length - 4]?.createdAt).getTime() <=
          new Date(todayDate).getTime()) ||
          (new Date(trip.follow_up[trip.follow_up.length - 5]?.createdAt).getTime() >=
          new Date(yesterday).getTime() &&
          new Date(trip.follow_up[trip.follow_up.length - 5]?.createdAt).getTime() <=
          new Date(todayDate).getTime())
    );
    const leadfupdby = data.data.filter(
      (trip) =>
      trip.trip_status !=="Converted" &&
        trip.follow_up &&
        trip.follow_up[trip.follow_up.length - 1]?.time !== "00:00" &&
        
       
        trip.follow_up.length > 0 &&
        (new Date(trip.follow_up[trip.follow_up.length - 1]?.createdAt).getTime() >=
          new Date(dby).getTime() &&
          new Date(trip.follow_up[trip.follow_up.length - 1]?.createdAt).getTime() <=
          new Date(yesterday).getTime()) ||
          (new Date(trip.follow_up[trip.follow_up.length - 2]?.createdAt).getTime() >=
            new Date(dby).getTime() &&
            new Date(trip.follow_up[trip.follow_up.length - 2]?.createdAt).getTime() <=
            new Date(yesterday).getTime()) ||
            (new Date(trip.follow_up[trip.follow_up.length - 3]?.createdAt).getTime() >=
              new Date(dby).getTime() &&
              new Date(trip.follow_up[trip.follow_up.length - 3]?.createdAt).getTime() <=
              new Date(yesterday).getTime()) ||
              (new Date(trip.follow_up[trip.follow_up.length - 4]?.createdAt).getTime() >=
                new Date(dby).getTime() &&
                new Date(trip.follow_up[trip.follow_up.length - 4]?.createdAt).getTime() <=
                new Date(yesterday).getTime()) ||
                (new Date(trip.follow_up[trip.follow_up.length - 5]?.createdAt).getTime() >=
                  new Date(dby).getTime() &&
                  new Date(trip.follow_up[trip.follow_up.length - 5]?.createdAt).getTime() <=
                  new Date(yesterday).getTime()) ||
                  (new Date(trip.follow_up[trip.follow_up.length - 6]?.createdAt).getTime() >=
                    new Date(dby).getTime() &&
                    new Date(trip.follow_up[trip.follow_up.length - 6]?.createdAt).getTime() <=
                    new Date(yesterday).getTime()) ||
                    (new Date(trip.follow_up[trip.follow_up.length - 7]?.createdAt).getTime() >=
                      new Date(dby).getTime() &&
                      new Date(trip.follow_up[trip.follow_up.length - 7]?.createdAt).getTime() <=
                      new Date(yesterday).getTime())
    );
    if(filterData2.date=="D"){
      // if(filterData2.call_must=="True"){
      //   const leadfuptoday2=leadfuptoday.filter(data => (new Date(data.createdAt).getTime()<new Date(todayDate).getTime()) && calltrue2(data))
      //   setallfollowupData(leadfuptoday2)
      // }else{
        const leadfuptoday2=leadfuptoday.filter(data => (new Date(data.createdAt).getTime()<new Date(todayDate).getTime()))
        setallfollowupData(leadfuptoday2)
      // }
      
    }else if(filterData2.date=="D-1"){
      // if(filterData2.call_must=="True"){
      // const leadfupyesterday2=leadfupyesterday.filter(data => (new Date(data.createdAt).getTime()<new Date(yesterday).getTime()) && calltrue2(data))
      // setallfollowupData(leadfupyesterday2)
      // }else{
        const leadfupyesterday2=leadfupyesterday.filter(data => (new Date(data.createdAt).getTime()<new Date(yesterday).getTime()))
        setallfollowupData(leadfupyesterday2)
      // }
    }else if(filterData2.date=="D-2"){
      // if(filterData2.call_must=="True"){
      // const leadfupdby2=leadfupdby.filter(data => (new Date(data.createdAt).getTime()<new Date(dby).getTime()) && calltrue2(data))
      // setallfollowupData(leadfupdby2)
      // }else{
        const leadfupdby2=leadfupdby.filter(data => (new Date(data.createdAt).getTime()<new Date(dby).getTime()))
      setallfollowupData(leadfupdby2)
      }
    // }
  }else{
    alert("Please select trip owner and date")
  }
}

const checkcall=(tripdata)=>{
  var temp=""
  let cr=tripdata.callrecord
  if(cr && cr.length>0){
    if(filterData2.date=="D"){
    for(let i=0;i<cr.length;i++){
      if(new Date(cr[i].start_stamp).getTime()>=new Date(todayDate).getTime() && new Date(cr[i].start_stamp).getTime()<=new Date(nextDate).getTime()){
        if(parseInt(cr.duration)<15){
          temp="Not enough ring time"
        }else{
          temp=cr[i].call_status+" - "+cr[i].outbound_sec+" - "+cr[i].start_stamp
        }
      }else{
        temp="Not done"
      }
    }
  }else if(filterData2.date=="D-1"){
    for(let i=0;i<cr.length;i++){
      // if(tripdata.trip_id=="32185"){
      //   console.log(cr[i])
      //   console.log(new Date(cr[i].start_stamp).getTime())
      //   console.log(new Date(yesterday).getTime())
      //   console.log(new Date(todayDate).getTime())
      // }
      if(new Date(cr[i].start_stamp).getTime()>=new Date(yesterday).getTime() && new Date(cr[i].start_stamp).getTime()<=new Date(todayDate).getTime()){
      if(parseInt(cr.duration)<15){
        temp="Not enough ring time"
      }else{
        temp=cr[i].call_status+" - "+cr[i].outbound_sec+" - "+cr[i].start_stamp
      }
        
      }else{
        temp="Not done"
      }
    }

  }else if(filterData2.date=="D-2"){
    for(let i=0;i<cr.length;i++){
      if(new Date(cr[i].start_stamp).getTime()>=new Date(dby).getTime() && new Date(cr[i].start_stamp).getTime()<=new Date(yesterday).getTime()){
        if(parseInt(cr.duration)<15){
          temp="Not enough ring time"
        }else{
          temp=cr[i].call_status+" - "+cr[i].outbound_sec+" - "+cr[i].start_stamp
        }
      }else{
        temp="Not done"
      }
    }
    
  }else{
    for(let i=0;i<cr.length;i++){
      if(new Date(cr[i].start_stamp).getTime()>=new Date(todayDate).getTime() && new Date(cr[i].start_stamp).getTime()<=new Date(nextDate).getTime()){
        if(parseInt(cr.duration)<15){
          temp="Not enough ring time"
        }else{
          temp=cr[i].call_status+" - "+cr[i].outbound_sec+" - "+cr[i].start_stamp
        }
      }else{
        temp="Not done"
      }
    }
  }
  return temp
  }else{
    temp="No record found"
    return temp
  }
}

const loadtripcanc=async()=>{
  let startdate=DateCalc(-2)
  let enddate=DateCalc(1)
  if(role=="Sales"  || role=="SME" ){
    const data=await fetchcancflagbydateandowner(startdate, enddate, cuser)
    console.log(data.data)
    // var bannedlist=employeelist.filter(e=>("permissions" in e && e.permissions.manual_cancellation))
    // var bannedlist2=bannedlist.map(e=>e.short_name)
    // var temp=data.data.filter(t=>!(bannedlist2.includes(t.trip_owner) && t.canc_reason=="System-manual cancellation"))
    setcancData2(data.data)
  }else{
  const data=await fetchcancflagbydate(startdate, enddate)
  console.log(data.data)
  setcancData2(data.data)
  }
}

const handleClose=async()=>{
  setOpen(false)
}

const handlequoteSearch = async (cuser) => {
  try{
 
    const today=DateCalc(0)
    const tomorrow=DateCalc(1)

      const data = await newsearchQEbyDateandOwner(
        today, tomorrow, cuser
      );
      const data2=data.data.filter(q=>new Date(q.updatedAt).getTime()>new Date(q.createdAt).getTime())
      setlistquoteData2(data2);

   
   


    const data3 = await searchQCbyDateandOwner(
      today, tomorrow, cuser
    );
    setlistquoteData3(data3.data);
    // const Ind=data.data.filter(q=>q.primary_destination=="Bali")
    //console.log(data3.data)
 

}catch(err){
console.log(err)
}
};

const geturgent=(tripid)=>{
  const temp=paymentData.filter(trip=>trip.trip_id==tripid)
  if(temp.length>0){
    return getprofit(temp[0]) - (total(temp[0].cust_payments)-pending(temp[0].cust_payments))<0?((total(temp[0].cust_payments)-pending(temp[0].cust_payments))<10000?true:false):true
  }else{
    return ""
  }
}

const getdestination=(number, type)=>{
  var temp=leadlistData.filter(l=>l.mobile_number==number)
  const temp2=temp.sort((a,b)=>new Date(b.createdAt).getTime()-new Date(a.createdAt).getTime())
  if(type==1){
  return temp2.length>0 && "lead_destination" in temp2[0]?temp2[0].lead_destination:""
  }else{
   return temp2.length>0 && "lead_owner" in temp2[0]?temp2[0].lead_owner:"" 
  }
}



   useEffect(() => {
      if (!loading) {
        if(cuser){
      getDest()
      getEmployees()
      getTasksbyOwner(cuser)
    }
      }
      if(role == "Sales" || role == "SME"){
      getFollowupbyTripOwner(cuser)
      getCustbyOwner(cuser)
      getLeadbyLeadOwner(cuser)
      //getCancbyOwner(cuser, cancdate)
      getTripsbyTripOwner(cuser)
      getTripssd(cuser)
      //handlequoteSearch(cuser)
      setexpanded1(true)
      setexpanded2(true)
      setexpanded3(true)
      setexpanded4(true)
      setexpanded5(true)
      setexpanded6(true)
      setexpanded7(true)
      setexpanded8(true)
      setexpanded9(true)
      setexpanded10(true)
      setexpanded11(true)
      setexpanded12(true)
      setexpanded13(true)
      setexpanded14(true)
      setexpanded15(true)
      setexpanded16(true)
    }else if(role=="Operations" || role=="Operations-TL" || role=="Product"){
      getconvtrips()
      setopsfilterData({owner:cuser})
    }
    }, [loading, cuser, role, employeelist, destinationlist]);

  //Followup data

  var followupdatalistdisplay = [];
  const fupfinalDate = DateCalc(0);
var f1=[]
  if(filterData.trip_owner && filterData.trip_status){
    f1=followupData.filter(tripdata => tripdata.trip_owner==filterData.trip_owner && tripdata.trip_status==filterData.trip_status)
  }else if(filterData.trip_owner){
    f1=followupData.filter(tripdata => tripdata.trip_owner==filterData.trip_owner)
  } else if(filterData.trip_status){
    f1=followupData.filter(tripdata => tripdata.trip_status==filterData.trip_status)
  }else{
    f1=followupData
  }
  if(filterData.call_must=="True"){
    f1=f1.filter(tripdata=>calltrue2(tripdata))
  }
//console.log(followupData)
//   console.log(f1)
 
  const f = f1.filter(
    (tripdata) => tripdata.trip_status !== "Closed" && tripdata.trip_status !== "Converted" &&
      tripdata.follow_up.filter(
        (fup) => fup.date <= fupfinalDate && fup.status == "Open" && fup.time !== "00:00"
      ).length > 0
  );

  const f2 = f1.filter(
    (tripdata) => tripdata.trip_status !== "Closed" && tripdata.trip_status !== "Converted" &&
      tripdata.follow_up.filter(
        (fup) => fup.status == "Open"
      ).length > 0
  );

  const f3 = f1.filter(
    (tripdata) => tripdata.trip_status !== "Closed" && tripdata.trip_status !== "Converted" &&
      tripdata.follow_up.filter(
        (fup) => fup.date <= fupfinalDate && fup.status == "Open"
      ).length > 0
  );
 

  if (tdfup) {
    followupdatalistdisplay = f.map((tripdata) => ({
      cust_name: tripdata.cust_name,
      id: followupData.indexOf(tripdata),
      trip_id: tripdata.trip_id,
      date: tripdata.follow_up
        .map((fup) => (fup.status == "Open" ? fup.date : null))
        .join(""),
      time: tripdata.follow_up
        .map((fup) => (fup.status == "Open" ? fup.time : null))
        .join(""),
      prev_note: tripdata.follow_up[tripdata.follow_up.length - 2]
        ? tripdata.follow_up[tripdata.follow_up.length - 2].notes
        : null,
      current_note: tripdata.follow_up[tripdata.follow_up.length - 1]
        ? tripdata.follow_up[tripdata.follow_up.length - 1].notes
        : null,
      fup_type: tripdata.follow_up[tripdata.follow_up.length - 1]
        ? tripdata.follow_up[tripdata.follow_up.length - 1].fuptype
        : null,
      trip_status: tripdata.trip_status,
      trip_owner: tripdata.trip_owner,
      trip_start_date:tripdata.trip_start_date,
      potential:((("lead") in tripdata) && ("potential" in tripdata.lead))?tripdata.lead.potential:"",
      trip_created_date:tripdata.createdAt,
    }));
  } else {
    followupdatalistdisplay = f2.map((tripdata) => ({
      cust_name: tripdata.cust_name,
      id: followupData.indexOf(tripdata),
      trip_id: tripdata.trip_id,
      date: tripdata.follow_up
        .map((fup) => (fup.status == "Open" ? fup.date : null))
        .join(""),
      time: tripdata.follow_up
        .map((fup) => (fup.status == "Open" ? fup.time : null))
        .join(""),
      prev_note: tripdata.follow_up[tripdata.follow_up.length - 2]
        ? tripdata.follow_up[tripdata.follow_up.length - 2].notes
        : null,
      current_note: tripdata.follow_up[tripdata.follow_up.length - 1]
        ? tripdata.follow_up[tripdata.follow_up.length - 1].notes
        : null,
      fup_type: tripdata.follow_up[tripdata.follow_up.length - 1]
        ? tripdata.follow_up[tripdata.follow_up.length - 1].fuptype
        : null,
      trip_status: tripdata.trip_status,
      trip_owner: tripdata.trip_owner,
      trip_start_date: tripdata.trip_start_date,
      potential:((("lead") in tripdata) && ("potential" in tripdata.lead))?tripdata.lead.potential:"",
      trip_created_date:tripdata.createdAt,
      qp:tripdata.quote_pending,
      pna:"prev_next_action" in tripdata?tripdata.prev_next_action:"",
    }));
  }
  const followupdatalistdisplay01= f3.map((tripdata) => ({
    cust_name: tripdata.cust_name,
    pna:"prev_next_action" in tripdata?tripdata.prev_next_action:"",
    id: followupData.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    date: tripdata.follow_up
      .map((fup) => (fup.status == "Open" ? fup.date : null))
      .join(""),
    time: tripdata.follow_up
      .map((fup) => (fup.status == "Open" ? fup.time : null))
      .join(""),
    prev_note: tripdata.follow_up[tripdata.follow_up.length - 2]
      ? tripdata.follow_up[tripdata.follow_up.length - 2].notes
      : null,
    current_note: tripdata.follow_up[tripdata.follow_up.length - 1]
      ? tripdata.follow_up[tripdata.follow_up.length - 1].notes
      : null,
    fup_type: tripdata.follow_up[tripdata.follow_up.length - 1]
      ? tripdata.follow_up[tripdata.follow_up.length - 1].fuptype
      : null,
    trip_status: tripdata.trip_status,
    trip_owner: tripdata.trip_owner,
    trip_start_date: tripdata.trip_start_date,
    potential:((("lead") in tripdata) && ("potential" in tripdata.lead))?tripdata.lead.potential:"",
    lead_status:(("lead") in tripdata)?getquality(tripdata.lead.lead_status, tripdata.lead.time_to_book, tripdata.trip_channel, tripdata.trip_start_date, tripdata.lead.quality_upgrade, null):getquality(null, null, tripdata.trip_channel, tripdata.trip_start_date, null, null),
    qp:tripdata.quote_pending,
    trip_created_date:tripdata.createdAt,
  }));

  const followupdatalistdisplay00 = f3.map((tripdata) => ({
    cust_name: tripdata.cust_name,
    id: followupData.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    date: tripdata.follow_up
      .map((fup) => (fup.status == "Open" ? fup.date : null))
      .join(""),
    time: tripdata.follow_up
      .map((fup) => (fup.status == "Open" ? fup.time : null))
      .join(""),
    prev_note: tripdata.follow_up[tripdata.follow_up.length - 2]
      ? tripdata.follow_up[tripdata.follow_up.length - 2].notes
      : null,
    current_note: tripdata.follow_up[tripdata.follow_up.length - 1]
      ? tripdata.follow_up[tripdata.follow_up.length - 1].notes
      : null,
    fup_type: tripdata.follow_up[tripdata.follow_up.length - 1]
      ? tripdata.follow_up[tripdata.follow_up.length - 1].fuptype
      : null,
    trip_status: tripdata.trip_status,
    trip_owner: tripdata.trip_owner,
    trip_start_date: tripdata.trip_start_date,
    potential:((("lead") in tripdata) && ("potential" in tripdata.lead))?tripdata.lead.potential:"",
    trip_created_date:tripdata.createdAt,
    qp:tripdata.quote_pending,
    pna:"prev_next_action" in tripdata?tripdata.prev_next_action:"",
  }));

  //Payment data
  const finalDate = DateCalc(3);
  const finalDate3 = DateCalc(-1);
  const finalDate2 = DateCalc(7);
  // console.log(finalDate2)
  //console.log(finalDate, finalDate2)
  const paymentdata1 = paymentData? paymentData.filter(
    (trip) => trip.cust_payments?.length > 0
  ):[];
  const paymentdata2 = paymentdata1.map((trip) =>
    trip.cust_payments.map((item) =>
      item.status == "Pending" && item.date.split("T").slice(0, 1) <= finalDate
        ? [
            item.date,
            item.amount,
            trip.trip_id,
            "booking" in trip && "ops_assigned" in trip.booking?trip.booking.ops_assigned:"",
            trip.cust_name,
            trip.booking.ops_assigned,
            trip.trip_start_date,
            trip.payment_note
          ]
        : []
    )
  );
  const paymentdata3 = paymentdata2.map((item) =>
    item.filter((arr) => arr.length !== 0)
  );
  let paymentdata4 = [];
  for (let i = 0; i < paymentdata3.length; i++) {
    paymentdata4 = paymentdata4.concat(paymentdata3[i]);
  }
  //console.log(paymentdata4)
  const paymentdatalistdisplay = paymentdata4.map((paymentdata) => ({
    cust_name: paymentdata[4],
    id: paymentdata4.indexOf(paymentdata),
    trip_id: paymentdata[2],
    date: paymentdata[0].slice(0,10),
    amount: paymentdata[1],
    trip_owner: paymentdata[3],
    ops_owner:paymentdata[5], 
    trip_start_date:paymentdata[6],
    urgent:geturgent(paymentdata[2]),
    payment_note:paymentdata[7],
  }));

  //supplier payment
  const suppaymentdata1 = paymentData? paymentData.filter(
    (trip) => trip.supplier_payments?.length > 0
  ):[];

  var suppaydue=[]
  if(suppaymentdata1.length>0){
    var x=1
  for(let i=0; i<suppaymentdata1.length; i++){
    for(let j=0; j<suppaymentdata1[i].supplier_payments.length; j++){
      if(suppaymentdata1[i].supplier_payments[j].status=="Refund Due"){
      const temp={
        id:x,
        trip_id:suppaymentdata1[i].trip_id,
        cust_name:suppaymentdata1[i].cust_name,
        name:suppaymentdata1[i].supplier_payments[j].name,
        amount:suppaymentdata1[i].supplier_payments[j].amount,
        status:suppaymentdata1[i].supplier_payments[j].status,
      }
      suppaydue=[...suppaydue, temp]
      x++
    }
    }
    
  }
}

  const suppaymentdata2 = suppaymentdata1.map((trip) =>
    trip.supplier_payments.map((item) =>
      item.status == "Pending" && item.date && item.date.split("T").slice(0, 1) <= finalDate
        ? [
            item.date,
            item.amount,
            trip.trip_id,
            trip.trip_owner,
            trip.cust_name,
            item.name,
            "booking" in trip && "ops_assigned" in trip.booking?trip.booking.ops_assigned:"",
          ]
        : []
    )
  );

 

  const suppaymentdata3 = suppaymentdata2.map((item) =>
    item.filter((arr) => arr.length > 0)
  );

  

  let suppaymentdata4 = [];
  for (let i = 0; i < suppaymentdata3.length; i++) {
    suppaymentdata4 = suppaymentdata4.concat(suppaymentdata3[i]);
  }

  const suppaymentdatalistdisplay = suppaymentdata4.map((paymentdata) => ({
    cust_name: paymentdata[4],
    id: suppaymentdata4.indexOf(paymentdata),
    trip_id: paymentdata[2],
    date: paymentdata[0],
    amount: paymentdata[1],
    trip_owner: paymentdata[3],
    ops_owner:paymentdata[6], 
    name: paymentdata[5],
  }));
  //console.log(suppaymentdatalistdisplay)
    //postsales display
  var psdata2 = [];
  psdata2 = paymentData.filter(
    (trip) =>
      new Date(trip.trip_start_date).getTime() > new Date(finalDate3).getTime() &&
      new Date(trip.trip_start_date).getTime() <= new Date(finalDate2).getTime()
  );

  const postsalesdatalistdisplay = psdata2.map((psdata) => ({
    flight_ticket: psdata.flight_ticket,
    id: psdata2.indexOf(psdata),
    trip_id: psdata.trip_id,
    trip_start_date: "trip_start_date" in psdata && psdata.trip_start_date?psdata.trip_start_date.slice(0,10):"",
    destination:psdata.primary_destination,
    hotel_voucher: psdata.hotel_voucher,
    land_voucher: psdata.land_voucher,
    visa: psdata.visa,
    check_in: psdata.check_in,
    driver_number: psdata.driver_number,
    ops_owner:psdata.booking?psdata.booking.ops_assigned:"", 
    post_sales_notes: psdata.post_sales_notes,
    cust_name: psdata.cust_name,
  }));

  //customer followup display
  var custfollowupdatalistdisplay = [];
  var custData2 = custData.filter(
    (c) => "follow_up" in c && c.follow_up && "status" in c.follow_up && c.follow_up.status == "Open")
  var custlist=[...custData2]
  if(showall){
    custlist=custlist.filter((c) =>  !(getdestination(c.primary_mobile_number, 2)=="Abhishek" || getdestination(c.primary_mobile_number, 2)=="RohitS" || getdestination(c.primary_mobile_number, 2)==""))
  }
  if(filterData.trip_owner){
    custlist=custlist.filter(trip=> trip.follow_up.owner==filterData.trip_owner)
  }
  console.log(custlist)
  custfollowupdatalistdisplay = custlist.map((custdata) => ({
    cust_name: custdata.cust_name,
    id: custlist.indexOf(custdata),
    cust_id: custdata.cust_id,
    date: custdata.follow_up.date,
    time: custdata.follow_up.time,
    note: custdata.follow_up.notes,
    owner: custdata.follow_up.owner,
    last_assigned_by:custdata.follow_up.updated_by,
    lead_owner:"primary_mobile_number" in custdata?getdestination(custdata.primary_mobile_number, 2):"",
    dest:"primary_mobile_number" in custdata?getdestination(custdata.primary_mobile_number, 1):""
  }));

  //lead display
  //console.log(dupData)
  var leaddatalistdisplay = [];
  const leaddatalistdisplay2 = leadData2.map((leaddata) => ({
    cust_name: leaddata.lead_name,
    id: leadData2.indexOf(leaddata),
    lead_id: leaddata.lead_id,
    lead_destination: leaddata.lead_destination,
    phone_number: leaddata.mobile_number,
    work_done: leaddata.work_complete,
    dup_number:getdupnumber(leaddata.mobile_number),
    timetocreation: Math.round(((new Date().getTime()-new Date(leaddata.createdAt).getTime())*100)/(1000*60*60))/100,
    timetoassign: Math.round(((new Date().getTime()-new Date(leaddata.assignedAt).getTime())*100)/(1000*60*60))/100,
    lead_owner: leaddata.lead_owner,
    lead_platform: leaddata.lead_platform,
    lead_travel_date: leaddata.lead_travel_date,
    lead_quality:newgetqualitylead(leaddata),
    pax:leaddata.lead_pax?(leaddata.lead_child?(parseInt(leaddata.lead_pax)+parseInt(leaddata.lead_child)):parseInt(leaddata.lead_pax)):0,
  }));

  var l1=leadData.filter(l=>"lead_destination" in l && (!(l.lead_destination=="Gujarat" || l.lead_destination=="Turkey" || l.lead_destination=="Europe" || l.lead_destination=="Odisha" || l.lead_destination=="Madhya Pradesh" || l.lead_destination=="Tamil Nadu" || l.lead_destination=="Rajasthan" || l.lead_destination=="Golden Triangle" || l.lead_destination=="Meghalaya" || l.lead_destination=="" || l.lead_destination=="All") 
  || ((l.lead_destination=="Gujarat" || l.lead_destination=="Turkey" || l.lead_destination=="Europe" || l.lead_destination=="Odisha" || l.lead_destination=="Madhya Pradesh" || l.lead_destination=="Tamil Nadu" || l.lead_destination=="Rajasthan" || l.lead_destination=="Golden Triangle" || l.lead_destination=="Meghalaya" || l.lead_destination=="") && newgetqualitylead(l)=="Titanium")))

  if(leadfilterData.trip_owner && leadfilterData.destination){
    l1=l1.filter(leaddata => "lead_owner" in leaddata && leaddata.lead_owner==leadfilterData.trip_owner && "lead_destination" in leaddata  && leaddata.lead_destination && leaddata.lead_destination.toLowerCase()==leadfilterData.destination.toLowerCase())
  }else if(leadfilterData.trip_owner){
    l1=l1.filter(leaddata => "lead_owner" in leaddata && leaddata.lead_owner==leadfilterData.trip_owner)
  } else if(leadfilterData.destination){
    
    l1=l1.filter(leaddata => "lead_destination" in leaddata && leaddata.lead_destination && leaddata.lead_destination !=="" && leaddata.lead_destination.toLowerCase()==leadfilterData.destination.toLowerCase())
   
  }else{
    l1=[...l1]
  }
  if("higherpax" in leadfilterData && leadfilterData.higherpax!==""){
  if(leadfilterData.higherpax){
    
    l1=l1.filter(lead=>Number(lead.lead_pax)+("lead_child" in lead?Number(lead.lead_child):0)>4)
  }else{
    l1=l1.filter(lead=>Number(lead.lead_pax)+("lead_child" in lead?Number(lead.lead_child):0)<=4)
  }
}

if("fastreach" in leadfilterData && leadfilterData.fastreach!==""){
  if(leadfilterData.fastreach){
    
    l1=l1.filter(lead=>lead.fast_reach)
  }
}
  //console.log(l1.filter(l=>l.lead_destination=="Kerala"))

  if(leadfilterData.lead_status){
    l1=l1.filter(leaddata => leaddata.lead_status == leadfilterData.lead_status)
  }
  if(leadfilterData.lead_budget){
    l1=l1.filter(leaddata => leaddata.lead_budget == leadfilterData.lead_budget)
  }
  if(!showlq && copon && !(role=="Sales" || role == "SME")){
    l1=l1.filter(lead => !(newgetqualitylead(lead)=="Copper" || newgetqualitylead(lead)=="Silver" || lead.lead_destination=="Others"))
  }
  if(cuser=="Asgar"){
    l1=l1.filter(l=>l.lead_owner!=="RohitS")
  }
  if(cuser=="RohitS"){
    l1=l1.filter(l=>l.lead_owner!=="Abhishek")
  }

  leaddatalistdisplay = l1.map((leaddata) => ({
    cust_name: leaddata.lead_name,
    id: leadData.indexOf(leaddata),
    lead_id: leaddata.lead_id,
    lead_destination: leaddata.lead_destination,
    phone_number: leaddata.mobile_number,
    work_done: leaddata.work_complete,
    dup_number:getdupnumber(leaddata.mobile_number),
    timetocreation: Math.round(((new Date().getTime()-new Date(leaddata.createdAt).getTime())*100)/(1000*60*60))/100,
    timetoassign: Math.round(((new Date().getTime()-new Date(leaddata.assignedAt).getTime())*100)/(1000*60*60))/100,
    lead_owner: leaddata.lead_owner,
    lead_platform: leaddata.lead_platform,
    lead_travel_date: leaddata.lead_travel_date,
    lead_quality:newgetqualitylead(leaddata),
    pax:leaddata.lead_pax?(leaddata.lead_child?(parseInt(leaddata.lead_pax)+parseInt(leaddata.lead_child)):parseInt(leaddata.lead_pax)):0,
  }));
  //sdlist display
  const sddatalistdisplay=sdtrips.map(trip=>({
    trip_id: trip.trip_id,
    id: sdtrips.indexOf(trip),
    cust_name:trip.cust_name,
    trip_status:trip.trip_status,
    trip_owner:trip.trip_owner,
    primary_destination:trip.primary_destination,
    trip_start_date:trip.trip_start_date,
  }))

  // canclead display
  var cancdate=DateCalc(-3)
  var cancdatalistdisplay = [];
  var cancdatalistdisplay2 = [];
  var canclist=[]
  if(filterData.trip_owner){
    canclist=cancData.filter(trip=> trip.trip_owner==filterData.trip_owner)
    //setcanclistfinal(canclist)
  }else{
    canclist=[...cancData]
    //setcanclistfinal(canclist)
  }
  // if(canclist.length>0){
  //   console.log(canclist)
  //   setcanclistfinal(canclist)
  // }
  var cdata=removeDuplicates(canclist,"trip_id")
  cancdatalistdisplay = cdata.map((cancdata) => ({
    cust_name: cancdata.cust_name,
    id: cdata.indexOf(cancdata),
    trip_id: cancdata.trip_id,
    trip_status: cancdata.trip_status,
    last_updated_date:(cancdata.updatedAt),
    past_status:"prevStatus" in cancdata && cancdata.prevStatus && "new_status" in cancdata.prevStatus && cancdata.prevStatus.new_status?cancdata.prevStatus.new_status:"",
    trip_owner: cancdata.trip_owner,
    dest: cancdata.primary_destination,
    quality:(("lead") in cancdata)?getquality(cancdata.lead.lead_status, cancdata.lead.time_to_book, cancdata.trip_channel, cancdata.trip_start_date, cancdata.lead.quality_upgrade, null):getquality(null, null, cancdata.trip_channel, cancdata.trip_start_date,null, null),
    last_comment:"follow_up" in cancdata?cancdata.follow_up[cancdata.follow_up.length-1].notes:""
  }));

  cancdatalistdisplay2 = cdata.map((cancdata) => ({
    cust_name: cancdata.cust_name,
    id: cdata.indexOf(cancdata),
    trip_id: cancdata.trip_id,
    trip_status: cancdata.trip_status,
    last_updated_date:(cancdata.updatedAt),
    past_status:"prevStatus" in cancdata && cancdata.prevStatus && "new_status" in cancdata.prevStatus && cancdata.prevStatus.new_status?cancdata.prevStatus.new_status:"",
    canc_reason:cancdata.canc_reason,
    trip_owner: cancdata.trip_owner,
    dest: cancdata.primary_destination,
    canc_flag:cancdata.canc_flag,
    canc_flag_time:cancdata.canc_flag_time,
    quality:(("lead") in cancdata)?getquality(cancdata.lead.lead_status, cancdata.lead.time_to_book, cancdata.trip_channel, cancdata.trip_start_date, cancdata.lead.quality_upgrade, null):getquality(null, null, cancdata.trip_channel, cancdata.trip_start_date,null, null),
    last_comment:"follow_up" in cancdata?cancdata.follow_up[cancdata.follow_up.length-1].notes:""
  }));

  //operations data
  var opsdatalistdisplay = [];
  var l2=[]
  var l3=[]
  var l5=[]
  var l7=[]
 
  l2=listtripconvData2.filter(trip => ((!("booking" in trip))))
  l5=listtripconvData2.filter(trip => ("booking" in trip) && !("follow_up_date_text" in trip.booking))
  
  //l3=listtripconvData2.filter(trip => (("booking" in trip) && ((trip.booking.flight=="No") || (trip.booking.hotel=="No") || (trip.booking.land=="No") || (trip.booking.insurance=="No") || (trip.booking.visa=="No") || (trip.booking.others=="No"))))
  const one=DateCalc(1)
  l3=listtripconvData2.filter(trip => (("booking" in trip) && "follow_up_date_text" in trip.booking && new Date(trip.booking.follow_up_date_text).getTime()<=new Date(one).getTime()))
  //console.log(l3)
  const l6=l2.concat(l3)
  const l4=l6.concat(l5)
  if(opsfilterData.owner){
    l7=l4.filter(trip=>  ("ops_assigned" in trip.booking) && trip.booking.ops_assigned==opsfilterData.owner)
  }else{
    l7=[...l4]
  }
  opsdatalistdisplay = l7.map((tripdata) => ({
    cust_name: tripdata.cust_name, 
    id:listtripconvData2.indexOf(tripdata), 
    trip_id:tripdata.trip_id, 
    trip_start_date:"trip_start_date" in tripdata && tripdata.trip_start_date?tripdata.trip_start_date.slice(0,10):"",
    primary_destination:tripdata.primary_destination, 
    ops_owner:tripdata.booking?tripdata.booking.ops_assigned:"", 
    trip_owner:tripdata.trip_owner, 
    flight:tripdata.booking?tripdata.booking.flight:"",
    hotel:tripdata.booking?tripdata.booking.hotel:"",
    land:tripdata.booking?tripdata.booking.land:"",
    visa:tripdata.booking?tripdata.booking.visa:"",
    insurance:tripdata.booking?tripdata.booking.insurance:"",
    vm:tripdata.booking?tripdata.booking.voucher_matched:"",
    refund:tripdata.booking?tripdata.booking.refund_due:"",
    others:tripdata.booking?tripdata.booking.others:"",
    notes:tripdata.booking?tripdata.booking.notes:"",
    fup_date:tripdata.booking?"follow_up_date_text" in tripdata.booking?tripdata.booking.follow_up_date_text:"":"",
    conv_date:tripdata.status_history.length == 0
    ? ""
    : tripdata.status_history[tripdata.status_history.length - 1].date.slice(0,10)
      
  }));
 //console.log(opsdatalistdisplay)
 ////////////////////////////////////////////////

 const totalsp=(trip)=>{
  if(quoteData.length > 0){
 const quote=quoteData.filter(q=>q.trip_id==trip.trip_id && "quote_price" in q)
 if(quote.length > 0){
 return quote[0].quote_price.total + quote[0].quote_price.tcs
 }else{
  return 0
 }
  }else{
    return 0
  }
 }

//  const calctcs=(trip)=>{
//   if(quoteData.length > 0){
//  const quote=quoteData.filter(q=>q.trip_id==trip.trip_id && "quote_price" in q)
//  if(quote.length > 0){
//  return quote[0].quote_price.tcs
//  }else{
//   return 0
//  }
//   }else{
//     return 0
//   }
//  }
  //console.log(quoteData)
 const paymentdatalistdisplaycheck=paymentData2.map(trip=>({
  trip_id: trip.trip_id,
  id: paymentData2.indexOf(trip),
  ops_owner: "booking" in trip && "ops_assigned" in trip.booking? trip.booking.ops_assigned:"",
  cust_name:trip.cust_name,
  trip_start_date:trip.trip_start_date,
  trip_owner:trip.trip_owner,
  flag:trip.all_clear,
  pending:pending(trip.cust_payments),
  onhold:trip.on_hold,
  diff:Math.round(total(trip.cust_payments) - totalsp(trip)) ,
  totalcp:total(trip.cust_payments),
  conv_quote:trip.conv_quote,
  quotesp:totalsp(trip)
 }))
 /////////////////////////////////////////////////////////////////
 const taskdatalistdisplay=taskData.map(task=>({
  id: taskData.indexOf(task),
  task_id:task.task_id,
  trip_id:task.trip_id,
  task_status:task.task_status,
  task_category:task.task_category,
  task_priority:task.task_priority,
  deadline_date:task.deadline_date,
  deadline_time:task.deadline_time,
  task_description:task.task_description,
  assigned_by:task.assigned_by,
  assigned_to:task.assigned_to,
  created_at:task.createdAt,
 }))

 /////////////////////////////////////////////////////////////////////////////////////
 //Pending bookings
 const listtripconvData3=listtripconvData2.filter(trip=>"booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state=="Requested" || "booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state=="Rejected" || "booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state=="Back to Sales" || "booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state=="Just Converted")
 const convdatalistdisplaycheck=listtripconvData3.map(trip=>({
  trip_id: trip.trip_id,
  id: listtripconvData3.indexOf(trip),
  cust_name:trip.cust_name,
  trip_start_date:trip.trip_start_date,
  trip_owner:trip.trip_owner,
  transfer_state:trip.booking.transfer_state,
  ops_assigned:trip.booking.ops_assigned,
  conv_date:trip.status_history.length == 0
  ? ""
  : trip.status_history[trip.status_history.length - 1].date,
  profit:trip.cust_payments && trip.supplier_payments
  ? total(trip.cust_payments) -
    sptotal(trip.supplier_payments) -
    gettaxes(trip) -
    gettcs(trip)
  : 0,
 }))
 //////////////////////////////////////////////////////////////////////////////////
 var af=[]
if(filterData2.call_must=="True"){
  af=allfollowupData.filter(data => calltrue2(data))
}else{
  af=allfollowupData
}

 const allfollowupdatalistdisplay=af.map(tripdata=>({
 cust_name: tripdata.cust_name,
 id: af.indexOf(tripdata),
 trip_id: tripdata.trip_id,
 date: tripdata.follow_up
   .map((fup) => (fup.status == "Open" ? fup.date : null))
   .join(""),
 time: tripdata.follow_up
   .map((fup) => (fup.status == "Open" ? fup.time : null))
   .join(""),
 current_note: tripdata.follow_up[tripdata.follow_up.length - 1]
   ? tripdata.follow_up[tripdata.follow_up.length - 1].notes
   : null,
 fup_type: tripdata.follow_up[tripdata.follow_up.length - 1]
   ? tripdata.follow_up[tripdata.follow_up.length - 1].fuptype
   : null,
 trip_status: tripdata.trip_status,
 trip_owner: tripdata.trip_owner,
 trip_start_date: tripdata.trip_start_date,
 call_must: calltrue2(tripdata),
 call_attempted: checkcall(tripdata),
 potential: "lead" in tripdata && "potential" in tripdata.lead?tripdata.lead.potential:"",
 qp:tripdata.quote_pending,
 createdAt: tripdata.createdAt,
}))
const missedcall=callmissedData.filter(trip=>!(checkcall(trip).startsWith("ans") || checkcall(trip).startsWith("missed")) && trip.trip_owner==cuser && new Date(trip.createdAt).getTime()<new Date(todayDate).getTime())
const missedtrips=missedcall.map(trip=>trip.trip_id)
const missedqp=qpData.map(trip=>trip.trip_id)
//const missedcall2=callmissedData.map(trip=>checkcall(trip))
//console.log(missedcall2)
///////////////////////////////////////////////////////////////////////////////////////////
var canctrips=[]
if(filterData3.trip_owner){
  canctrips=cancData2.filter(trip=> trip.trip_owner==filterData3.trip_owner)
}else{
  canctrips=[...cancData2]
}

const cancflagdatalistdisplay=canctrips.map(cancdata=>({
    cust_name: cancdata.cust_name,
    id: canctrips.indexOf(cancdata),
    trip_id: cancdata.trip_id,
    trip_status: cancdata.trip_status,
    trip_owner: cancdata.trip_owner,
    dest: cancdata.primary_destination,
    reactivate:cancdata.reactivate,
    canc_flag:cancdata.canc_flag,
    canc_flag_time:new Date(cancdata.canc_flag_time).toLocaleString(undefined, {timeZone: 'Asia/Kolkata'}),
    last_comment:cancdata.follow_up[cancdata.follow_up.length-1].notes,
    prev_comment:cancdata.follow_up.length>1?cancdata.follow_up[cancdata.follow_up.length-2].notes:"",
    canc_reason:cancdata.canc_reason,
}))

//console.log(cancflagdatalistdisplay)
//--------------------------------------------------------------requested trips
var requestedtrips=[]
if(paymentData.length>0){
  requestedtrips=paymentData.filter(trip=>"booking" in trip && (trip.booking.transfer_state=="Requested" || trip.booking.transfer_state=="Back to Sales") && trip.trip_owner==cuser && trip.on_hold!==true)
}
const requestedtriplistcheck=requestedtrips.map(pd=>({
  id: requestedtrips.indexOf(pd),
  trip_id:pd.trip_id,
  cust_name:pd.cust_name,
  ops_owner:pd.booking.ops_assigned,
  on_hold:pd.on_hold,
  transfer_state:pd.booking.transfer_state,
  primary_destination:pd.primary_destination,
  trip_start_date:pd.trip_start_date,
}))

//----------------------------------quotes created and edited----------------------------------
const quotescreated=listquoteData3.map(q=>({
  id:listquoteData3.indexOf(q),
  quote_id:q.quote_id,
  trip_id:q.trip_id,
  owner:q.trip_owner,
  status:q.trip_status,
  destination:q.primary_destination,
  cust_name:q.cust_name,
  flight_sp:"quote_price" in q  && "airfare" in q.quote_price?Math.round(q.quote_price.airfare):0,
  flight_pp:"quote_price" in q  && "airfare" in q.quote_price?Math.round(q.quote_price.airfare/(q.number_adults+q.number_child)):0,
  land_sp:"quote_price" in q  && "landprice" in q.quote_price?q.quote_price.landprice:0,
  land_pp:"quote_price" in q  && "landprice" in q.quote_price?Math.round((q.quote_price.landprice/(q.number_adults+q.number_child))/q.duration):0,
  flight_profit:"quote_price" in q && "airfare" in q.cost_price?(Math.round(q.quote_price.airfare-q.cost_price.airfare)>0?Math.round(q.quote_price.airfare-q.cost_price.airfare):0):0,
  land_profit:"landprice" in q.quote_price && "landprice" in q.cost_price?Math.round(q.quote_price.landprice-q.cost_price.landprice):0,
  land_profit_perc:"landprice" in q.quote_price && "landprice" in q.cost_price?Math.round((q.quote_price.landprice-q.cost_price.landprice)/q.cost_price.landprice*100):0,
  note:listquoteData3.length>0?checkquotefault(q.primary_destination, q.number_adults, q.number_child, q.quote_price, q.cost_price, q.duration):"",
  created_at:q.createdAt,
}))

const quotesedited=listquoteData2.map(q=>({
  id:listquoteData2.indexOf(q),
  quote_id:q.quote_id,
  trip_id:q.trip_id,
  owner:q.trip_owner,
  status:q.trip_status,
  destination:q.primary_destination,
  cust_name:q.cust_name,
  flight_sp:"quote_price" in q  && "airfare" in q.quote_price?Math.round(q.quote_price.airfare):0,
  flight_pp:"quote_price" in q  && "airfare" in q.quote_price?Math.round(q.quote_price.airfare/(q.number_adults+q.number_child)):0,
  land_sp:"quote_price" in q  && "landprice" in q.quote_price?q.quote_price.landprice:0,
  land_pp:"quote_price" in q  && "landprice" in q.quote_price?Math.round((q.quote_price.landprice/(q.number_adults+q.number_child))/q.duration):0,
  flight_profit:"quote_price" in q && "airfare" in q.cost_price?(Math.round(q.quote_price.airfare-q.cost_price.airfare)>0?Math.round(q.quote_price.airfare-q.cost_price.airfare):0):0,
  land_profit:"landprice" in q.quote_price && "landprice" in q.cost_price?Math.round(q.quote_price.landprice-q.cost_price.landprice):0,
  land_profit_perc:"landprice" in q.quote_price && "landprice" in q.cost_price?Math.round((q.quote_price.landprice-q.cost_price.landprice)/q.cost_price.landprice*100):0,
  note:listquoteData2.length>0?checkquotefault(q.primary_destination, q.number_adults, q.number_child, q.quote_price, q.cost_price, q.duration):"",
  edited_at:q.updatedAtAt,
}))

  const assign= async() => {
    try{
    
    if(leadfilterData.assign_to == undefined){
      alert("Missing sales person name to assign")
    } else if(selection.length==0){
      alert("No item selected")
    }
    else {
      console.log(selection);
      const leadlist=selection.map(select => leadData[select].lead_id)
      console.log(leadlist);
      for (let i=0;i<leadlist.length;i++){
        const data = await fetchLeadbyId(leadlist[i]);
        data.data.lead_owner=leadfilterData.assign_to
        data.data.assignedAt=new Date()
        const updateleadResponse = await updateLeaddata(data.data._id, data.data);
      }
      window.location.reload();
    }
  }catch(err){
    console.log(err)
  }
  };

  const addselection=()=>{
    //console.log(selection)
    var count=0
    for(let i=0;i<leadselectionData.length;i++){
      count=count+leadselectionData[i].leads.length
    }
    console.log(count)
    var leadlist=[]
    if(leadfilterData.assign_to == undefined){
      alert("Missing sales person name to assign")
    } else if(selection.length==0){
      alert("No item selected")
    }else{
      for(let i=0;i<selection.length;i++){
        if(i>count-1){
        var temp={
          lead_id:leadData[selection[i]].lead_id, dest:leadData[selection[i]].lead_destination
        }
        leadlist=[...leadlist, temp]
      }
      }
      //const leadlist=selection.map(select => {lead_id:leadData[select].lead_id, dest:leadData[select].lead_id})
      let tempobj={
      name:leadfilterData.assign_to,
      leads:leadlist
    }
    setleadselectionData([...leadselectionData, tempobj])
    
    }
    
  }
  //console.log(selection)
  //console.log(leadselectionData)

  const addselection2=async()=>{
    
   if(selection2.length==0){
      alert("No item selected")
    }else{
      let x=window.confirm("Do you want to proceed with cancelling these trips?")
      if(x){
        console.log(selection2)
        //console.log(cancData2)
        const triplist=selection2.map(select => canctrips[select].trip_id)
        console.log(triplist)
        for(let i=0; i<triplist.length; i++){
          console.log(triplist[i])
          const data=await canceltripbytripid(triplist[i])
        }
        window.location.reload()
      }
      
    //setleadselectionData2(triplist)
    }
    
  }

   const addselection3=()=>{
    if(leadfilterData.cust_assign_to == undefined){
      alert("Missing sales person name to assign")
    } else if(selection3.length==0){
      alert("No item selected")
    }else{
      const custlist=selection3.map(select => custData2[select].cust_id)
      let tempobj={
      name:leadfilterData.cust_assign_to,
      custs:custlist
    }
    setcustselectionData([...custselectionData, tempobj])
    }
    
  }
  

  const newassign= async() => {
    try{
      var destarr=[]
      var namearr=["Asgar", "Rohit", "Amit","Abhishek"]
    const ruledata = await fetchRules();
    console.log(ruledata.data)
    console.log(leadselectionData)
    if("updatedAt" in ruledata.data[0] && new Date(ruledata.data[0].updatedAt).getTime()>new Date(DateCalc(0)).getTime()){

    
    // const data=await fetchfunnellength(leadfilterData.assign_to)
    // console.log(data)
   
      // const count=await openfupcountbysp(leadfilterData.assign_to)
      // console.log(count)
      // const opendata = await fetchCustomersbyOwner(leadfilterData.assign_to);
      // console.log(opendata.data)
      // const opendata2 = await fetchCustomersbyOwner("Abhishek");
      // console.log(opendata2.data)
     
      //if(leadfilterData.assign_to!=="Abhishek" && opendata.data.length<6){
    var alreadyassigned=[]
    if(leadselectionData.length>0){
     
      for (let i=0;i<leadselectionData.length;i++){
         console.log(leadselectionData[i].name)
         const data=await fetchfunnellength(leadselectionData[i].name)
          console.log(data)
          //check funnel size
        if(data.data<120){
          //check open cust size
          const count=await openfupcountbysp(leadselectionData[i].name)
          console.log(count)
          if((leadselectionData[i].name=="Abhishek" || leadselectionData[i].name=="RohitS") || (!(leadselectionData[i].name=="Abhishek" || leadselectionData[i].name=="RohitS") && count.data<6)){
              //if sp not available then exit
        const sp=ruledata.data[0].leadrule.filter(r=>r.name==leadselectionData[i].name)
        if(sp.length==0 || (sp.length>0 && sp[0].availability !=="Yes")){
          if(role=="Admin" || (leadselectionData[i].name=="RohitS" || leadselectionData[i].name=="Abhishek")){}else{
          alert("Warning: You are trying to assign lead to a non-available salesperson")
          return
          }
        }
        //list avaiable destinations
        if(sp.length>0){
          destarr=sp[0].destinations
        }
        if("leads" in leadselectionData[i] && leadselectionData[i].leads.length>0){
        for(let j=0;j<leadselectionData[i].leads.length;j++){
           if(role=="Admin" || (leadselectionData[i].name=="RohitS" || leadselectionData[i].name=="Abhishek")){
        
         if(!alreadyassigned.includes(leadselectionData[i].leads[j].lead_id && !namearr.includes(leadselectionData[i].name))){
            alreadyassigned=[...alreadyassigned,leadselectionData[i].leads[j].lead_id]
            
            // const data = await fetchLeadbyId(leadselectionData[i].leads[j]);
            // data.data.lead_owner=leadselectionData[i].name
            // data.data.assignedAt=new Date()
            console.log(leadselectionData[i].leads[j].lead_id, leadselectionData[i].name, cuser)
            const data = await newupdateLeaddata(leadselectionData[i].leads[j].lead_id, leadselectionData[i].name, cuser);
          }
      }else{
         if( destarr.includes(leadselectionData[i].leads[j].dest)){
           
          if(!alreadyassigned.includes(leadselectionData[i].leads[j].lead_id && !namearr.includes(leadselectionData[i].name))){
            alreadyassigned=[...alreadyassigned,leadselectionData[i].leads[j].lead_id]
            
            // const data = await fetchLeadbyId(leadselectionData[i].leads[j]);
            // data.data.lead_owner=leadselectionData[i].name
            // data.data.assignedAt=new Date()
            console.log(leadselectionData[i].leads[j].lead_id, leadselectionData[i].name, cuser)
            const data = await newupdateLeaddata(leadselectionData[i].leads[j].lead_id, leadselectionData[i].name, cuser);
          }
        }else{
          alert("Cannot assign lead id "+leadselectionData[i].leads[j].lead_id+" to "+leadselectionData[i].name+" due to destination mismatch")
        }
      }
        }
      }
          }else{
            alert("Cannot assign leads to "+leadselectionData[i].name+" as customer follow ups are pending")
            continue
          }
        
        }else{
    alert("Cannot assign leads to "+leadselectionData[i].name+" as funnel size is already too high")
    continue
  }
        
      }
      window.location.reload();
    } else if(selection.length==0){
      alert("No item selected")
    }
  // }else{
  //   alert("Cannot assign leads to "+leadfilterData.assign_to+" as customer follow ups are pending")
  // }

 
}else{
  alert("No record of Set Rule based lead assignment found")
}
    
  }catch(err){
    console.log(err)
  }
  };

  const newcustassign= async() => {
    try{
    console.log(custselectionData)  
    const data=await fetchfunnellength(leadfilterData.cust_assign_to)
    console.log(data.data)
    if(data.data<130){
      const count=await openfupcountbysp(leadfilterData.cust_assign_to)
      console.log(count)
      const opendata = await fetchCustomersbyOwner(leadfilterData.cust_assign_to);
      console.log(opendata.data)
      if(opendata.data.length<6){
    var alreadyassigned=[]
    if(custselectionData.length>0){
      for (let i=0;i<custselectionData.length;i++){
       
        if("custs" in custselectionData[i] && custselectionData[i].custs.length>0 && custselectionData[i].custs.length<7){
        for(let j=0;j<custselectionData[i].custs.length;j++){
          if(!alreadyassigned.includes(custselectionData[i].custs[j])){
            alreadyassigned=[...alreadyassigned,custselectionData[i].custs[j]]
            
            // const data = await fetchLeadbyId(leadselectionData[i].leads[j]);
            // data.data.lead_owner=leadselectionData[i].name
            // data.data.assignedAt=new Date()
            console.log(custselectionData[i].custs[j], custselectionData[i].name, cuser)
            const data = await newupdateCustdata(custselectionData[i].custs[j], custselectionData[i].name, cuser);
          }
          
        }
      }else{
        alert("Upto 6 leads can be assigned to a SP")
        return
      }
      }
      window.location.reload();
    } else if(selection.length==0){
      alert("No item selected")
    }
  }else{
    alert("Cannot assign leads to "+leadfilterData.cust_assign_to+" as customer follow ups are pending")
  }
  }else{
    alert("Cannot assign leads to "+leadfilterData.cust_assign_to+" as funnel size is already too high")
  }

    
  }catch(err){
    console.log(err)
  }
  };

  const loadcust=() =>{
    if(role=="TL"){
      getCustbyTL(cuser)
    }else{
      getCust()
    }
    
  }

  const loadlead=() =>{
    // if(role=="TL"){
    //   getLeadbyTL(cuser)
    // }else{
    //   getLead()
    // }
    getLead()
  }

  const getLead2=async() =>{
    let tripdata=[]
    var data={}
    try{
      if(role=="TL"){
        data = await fetchLeadsbyTL(cuser);
      }else{
        data = await fetchLeads15();
      }
    
      
      const temp=data.data.filter(lead=>newgetqualitylead(lead)!=="Iron" && "lead_destination" in lead && lead.lead_destination.length>1 && !("model_beta" in lead && lead.model_beta=="Beta"));
    const numberset=temp.map(lead=>lead.mobile_number)
    const data2=await fetchdupTripsbyNumber(numberset)

    setdupData(data2.data)
    setleadData(temp)
      
    //console.log(numberset)
    // for (let i=0;i<temp.length;i++){
    //   const data2=await fetchdupTripsbyNumber(temp[i].mobile_number)
    //   if(data2.data && data2.data.length>0){
    //     tripdata=[...tripdata, data2.data[data2.data.length-1]]
    //   }
    // }
    
  }catch(err){
    console.log(err)
  }
  }

  const handleclose2=()=>{
    setOpen2(false)
  }

  const getfunnelsize=async()=>{
    try{
      const data=await fetchfunnelsize()
      console.log(data.data)
      var temp2=[]
      for(let i=0;i<emp.length;i++){
        var x= data.data.filter(d=>d.trip_owner==emp[i])
        const temp={
          name: emp[i],
          count: x.length
        }
        temp2=[...temp2, temp]
      }
      setfunnel(temp2)
      setOpen2(true)
      console.log(temp2)
    }catch(err){
    console.log(err)
  }
  }

  const getLead3=async() =>{

    var button = document.getElementById('HQLeadsNew');
    
    // Disable the button to prevent multiple submissions
    button.disabled = true;

    // Simulate form submission (e.g., an AJAX request)
    setTimeout(function() {
        // Re-enable the button after the submission is complete
        button.disabled = false;

        // You can also submit the form here if needed
        // document.getElementById('myForm').submit();
    }, 5000);

    let tripdata=[]
    var data={}
    try{
      if(role=="TL" && cuser!=="Tarun"){
        data = await fetchLeadsbyTL(cuser);
      }else{
        data = await fetchLeads15();
      }
      console.log(data.data.sort((a, b) => (a.lead_id > b.lead_id ? 1 : -1)))
    console.log(data.data.filter(l=>l.lead_destination=="Kerala"))
    const temp=data.data.filter(lead=>newgetqualitylead(lead)!=="Iron" && "lead_destination" in lead && lead.lead_destination.length>1 && !("model_beta" in lead && lead.model_beta=="Beta"));
   
    console.log(temp.length)
    const numberset=temp.map(lead=>lead.mobile_number)
    const data2=await fetchdupTripsbyNumber(numberset)
    //console.log(data2.data)
    setdupData(data2.data)
    var temp2=[]
    for(let i=0;i<temp.length;i++){
    const x=data2.data.filter(t=> t.primary_mobile_number ==temp[i].mobile_number)
    if(temp[i].lead_id==226849 || temp[i].lead_id==226880){
      //console.log(x)
    }
    if(x && x.length > 0 ){
      for(let j=0;j<x.length;j++){
        var flag=1
        if(x[j].trip_status=="Active" || x[j].trip_status=="Hot"){
            if(cuser=="Debayan"){
            flag=0
            }
        }
      }
      if(flag){
        temp2=[...temp2, temp[i]]
      }
    }else{
    temp2=[...temp2, temp[i]]
    }
  }
    //console.log(temp2)
  console.log(temp2.length)
  setleadData(temp2)
  const opendata = await fetchCustomersbyOwner("Abhishek");
  console.log(opendata.data) 
  setopencust(opendata.data)
   
  }catch(err){
    console.log(err)
  }
  }

  const getLead4=async() =>{

    var button = document.getElementById('LQLeadsNew');
    
    // Disable the button to prevent multiple submissions
    button.disabled = true;

    // Simulate form submission (e.g., an AJAX request)
    setTimeout(function() {
        // Re-enable the button after the submission is complete
        button.disabled = false;

        // You can also submit the form here if needed
        // document.getElementById('myForm').submit();
    }, 5000);
    setshowlq(true)
    let tripdata=[]
    var data={}
    try{
      if(role=="TL"){
        data = await fetchLeadsbyTL(cuser);
      }else{
        data = await fetchLeads15();
      }
     
    const temp=data.data.filter(lead=>!(newgetqualitylead(lead)=="Platinum" || newgetqualitylead(lead)=="Rhodium" || newgetqualitylead(lead)=="Diamond" || newgetqualitylead(lead)=="Gold" || newgetqualitylead(lead)=="Titanium") && "lead_destination" in lead && lead.lead_destination.length>1);
   
    console.log(temp.length)
    const numberset=temp.map(lead=>lead.mobile_number)
    const data2=await fetchdupTripsbyNumber(numberset)
    console.log(data2.data)
    setdupData(data2.data)
    var temp2=[]
    for(let i=0;i<temp.length;i++){
    const x=data2.data.filter(t=> t.primary_mobile_number ==temp[i].mobile_number)
    if(temp[i].lead_id==226849 || temp[i].lead_id==226880){
      console.log(x)
    }
    if(x && x.length > 0 ){
      for(let j=0;j<x.length;j++){
        var flag=1
        if(x[j].trip_status=="Active" || x[j].trip_status=="Hot"){
            if(cuser=="Debayan"){
            flag=0
            }
        }
      }
      if(flag){
        temp2=[...temp2, temp[i]]
      }
    }else{
    temp2=[...temp2, temp[i]]
    }
  }
    //console.log(temp2)
  console.log(temp2.length)
  setleadData(temp2)
  const opendata = await fetchCustomersbyOwner("Abhishek");
  console.log(opendata.data) 
  setopencust(opendata.data)  
    //console.log(tripdata)
   
  }catch(err){
    console.log(err)
  }
  }

  const loadops=() =>{
    // if(role=="TL"){
    //   getTripsbyTL(cuser)
    // }else{
    //   getconvtrips()
    // }
    getconvtrips()
  }

  const loadtclead=() =>{
    let hr = prompt("Enter hours:");
    let mn = prompt("Enter minutes:");
    postTCLead(hr,mn)
  }

  const loadcanc=() =>{
    if(role=="TL"){
      getCancbyTL(cuser, cancdate)
    }else{
      getCanc(cancdate)
    }
    
  }

  const loadsd=async() =>{
    try{
    const startdate=DateCalc(-365)
    const enddate=DateCalc(7)
    const data=await searchTripsbyStartDate(startdate,enddate)
    setsdtrips(data.data.filter(trip=>trip.trip_status !=="Converted" && trip.trip_status !=="Closed" && trip.trip_status !=="Cancelled" && trip.trip_status !=="Booked Outside" && trip.trip_status!=="Dropped After Booking"))
  }catch(err){
    console.log(err)
  }
  }

  const getTripssd=async(cuser) =>{
    try{
    const startdate=DateCalc(-365)
    const enddate=DateCalc(7)
    const data=await searchTripsbyStartDateandowner(startdate,enddate, cuser)
    setsdtrips(data.data)
  }catch(err){
    console.log(err)
  }
  }
  
  const gridcellclick = (id) => {
    //window.location = "/tripdataentry/" + id;
    window.open("/tripdataentry/" + id, '_blank');
    //console.log("/custdataentry/"+id);
  };

  const custcellclick = (id) => {
    window.open("/custdataentry/" + id,'_blank') 
    //console.log("/custdataentry/"+id);
  };

  const gridcellclickpayment = (id) => {
    window.open("/tripdataentry/" + id + "/paymentupdate",'_blank')
    //console.log("/custdataentry/"+id);
  };

  const gridcellclicklead = (id) => {
    window.open("/lead/" + id,'_blank');
    //console.log("/custdataentry/"+id);
  };

  const gridcellclicktask = (id) => {
    window.open("/taskdataentry/" + id,'_blank');
    //console.log("/custdataentry/"+id);
  };

  const changeisOwner = () => {
    setisOwner(!isOwner);
    if (!isOwner) {
      role = "Sales";
    } else {
      role = "Admin";
    }
    role == "Admin" ? getFollowups() : getFollowupbyTripOwner(cuser);
    role == "Admin" ? getCust() : getCustbyOwner(cuser);
    role == "Admin" ? getLead() : getLeadbyLeadOwner(cuser);
  };

  const change0000 = () => {
    setshow0000(!show0000);
   
  };

  const changefollowup = () => {
    settdfup(!tdfup);
  };

  const handleClose4 = () => {
    setdialog1(false);
  };

  const getleadcount=(emp, dest)=>{
    const temp= l1.filter(lead=>lead.lead_destination==dest && lead.lead_owner==emp)
    //console.log(temp.length)
    return temp.length
  }

  const getleaddestcount=(dest)=>{
    // console.log(dest)
    // console.log(leadData)
    const temp= l1.filter(lead=>lead.lead_destination==dest)
    //console.log(temp.length)
    return temp.length
  }

  const getleadempcount=(emp)=>{
    const temp= l1.filter(lead=>lead.lead_owner==emp)
    //console.log(temp.length)
    return temp.length
  }

  const gridcellclickquote=(id)=>{
    window.open("/quotedataentry/" + id,'_blank');
    //console.log("/custdataentry/"+id);
  }

  const showmissed=()=>{
    alert(JSON.stringify(missedtrips))
  }

  const showqp=()=>{
    alert(JSON.stringify(missedqp))
  }

  const get12pm=async(name)=>{
    try{
      const data=await get12pmreport(name)
      console.log(data.data)
      const text="Hot Pending: "+data.data.hot.toString()+"\n\n"+"Pot Pending: "+data.data.pot.toString()
      
      alert(text)
    }catch(e){
      console.log(e)
    }
  }

  const loadfupcheck=async()=>{
    const data=await currentfupcount()
    console.log(data.data)
    setfupcheckdata(data.data)
    console.log(data.data.filter(t=>t.trip_owner=="Aakash"))
  }
  var fupcheckdata2=[...fupcheckdata]
  fupcheckdata2=fupcheckdata2.map(f=>("follow_up" in f && new Date(f.follow_up.date).getTime()>=new Date(DateCalc(1)).getTime()?{...f, new_status:"Closed"}:{...f,new_status:"Open"}))
  if(filterData7.trip_owner){
    fupcheckdata2=fupcheckdata2.filter(t=>t.trip_owner==filterData7.trip_owner)
  }
   if(filterData7.called_today){
    fupcheckdata2=fupcheckdata2.filter(t=>t.calledtoday==filterData7.called_today)
  }
   if(filterData7.status){
    fupcheckdata2=fupcheckdata2.filter(t=>t.new_status==filterData7.status)
  }
   if(filterData7.created){
    if(filterData7.created=="Today"){
      fupcheckdata2=fupcheckdata2.filter(t=>new Date(t.createdAt).getTime()>new Date(DateCalc(0)).getTime())
    }else{
      fupcheckdata2=fupcheckdata2.filter(t=>new Date(t.createdAt).getTime()<new Date(DateCalc(0)).getTime())
    }
  }
  //console.log(fupcheckdata2)
  const fupcheckdisplay=fupcheckdata2.map(f=>({
  id: fupcheckdata2.indexOf(f),
  trip_id:f.trip_id,
  trip_owner:f.trip_owner,
  status:f && "follow_up" in f && new Date(f.follow_up.date).getTime()>=new Date(DateCalc(1)).getTime()?"Closed":"Open",
  note:f && "follow_up" in f && new Date(f.follow_up.date).getTime()>=new Date(DateCalc(1)).getTime()?f.follow_up.fupautonote:"",
  fup_time:"follow_up" in f?f.follow_up.createdAt:"",
  fup_by:"follow_up" in f?f.follow_up.createdby:"",
  called_today:f.calledtoday,
  called_by:"valid_call" in f?f.valid_call.answered_agent_name:"",
  called_time:"valid_call" in f?f.valid_call.start_stamp:"",
  skip_reason:"follow_up" in f?f.follow_up.skip_call_reason:"",
  createdAt:f.createdAt,
}))

  return (
    <div>
    {role!=="External"?(
      <div>
    <Dialog fullWidth maxWidth="m" open={dialog1} onClose={handleClose4}>
      <Table>
      <TableRow>
          {"Hitesh ("+sumlead1+")"}
          <hr></hr>
        </TableRow>
        <TableRow>
          {JSON.stringify(resultobject)}
          
        </TableRow>
        <TableRow>
        <br></br>
        {"Sidharth ("+sumlead2+")"}
          <hr></hr>
        </TableRow>
        <TableRow>
          {JSON.stringify(resultobject2)}
          
        </TableRow>
        
        <TableRow>
        <br></br>
          {"Yadvinder ("+sumlead3+")"}
          <hr></hr>
        </TableRow>
        <TableRow>
          {JSON.stringify(resultobject3)}
          
        </TableRow>

        <TableRow>
        <br></br>
          {"Tarun ("+sumlead4+")"}
          <hr></hr>
        </TableRow>
        <TableRow>
          {JSON.stringify(resultobject4)}
          
        </TableRow>

        <TableRow>
        <br></br>
          {"Tulsi ("+sumlead5+")"}
          <hr></hr>
        </TableRow>
        <TableRow>
          {JSON.stringify(resultobject5)}
          
        </TableRow>

        <TableRow>
        <br></br>
        {"NitinK ("+sumlead6+")"}
          <hr></hr>
        </TableRow>
        <TableRow>
          {JSON.stringify(resultobject6)}
          
        </TableRow>

        <TableRow>
        <br></br>
        {"Manish ("+sumlead7+")"}
          <hr></hr>
        </TableRow>
        <TableRow>
          {JSON.stringify(resultobject7)}
          
        </TableRow>

        <TableRow>
        <br></br>
        {"Qausain ("+sumlead8+")"}
          <hr></hr>
        </TableRow>
        <TableRow>
          {JSON.stringify(resultobject8)}
          
        </TableRow>

        <TableRow>
        <br></br>
        {"Others ("+sumleadothers+")"}
          <hr></hr>
        </TableRow>
        <TableRow>
          {JSON.stringify(resultobjectothers)}
        </TableRow>
      </Table>
    </Dialog>

    <Dialog fullWidth maxWidth="xl" open={Open} onClose={handleClose}>
      <Table>
      <TableRow>
      <TableCell>
          Total
        </TableCell>
      <TableCell>
          Employee
        </TableCell>
       
      {dest2.map(dest=>
        <TableCell>
          {dest}
        </TableCell>
      )}
      
      </TableRow>
      <TableRow>
      <TableCell>
          {l1.length}
        </TableCell>
      <TableCell>
          Total
        </TableCell>
        {dest2.map(dest=>
        <TableCell>
          {getleaddestcount(dest)}
        </TableCell>
      )}
        </TableRow>
      {emp.map(emp=>
      <TableRow>
      <TableCell>
      {getleadempcount(emp)}
        </TableCell>
      <TableCell>
          {emp}
        </TableCell>
        {dest2.map(dest=>
        <TableCell>
          {getleadcount(emp, dest)}
        </TableCell>
      )}
      
      </TableRow>
      )}
      
      </Table>
    </Dialog>

    <Dialog fullWidth maxWidth="m" open={Open2} onClose={handleclose2}>
      <Table>
      <TableRow>
      <TableCell>
          Employee
        </TableCell>
      <TableCell>
          Count
        </TableCell>
          
      </TableRow>
      {funnel.length>0 && funnel.map(data=>
      <TableRow>
       <TableCell>
          {data.name}
        </TableCell>
      <TableCell>
          {data.count}
        </TableCell>
        </TableRow>
      )}
      
      
      
      </Table>
    </Dialog>

      {role && emp.length>0 ?(
    <div>
    {/* <FormGroup row className={classes.formgroup}>
    <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={()=>setexpanded1(!expanded1)}
          >
            Accounts Double Check
          </Button> */}
    
    
    {role=="Admin" || role=="TL" || role=="Accounts"? (<div>
    <Paper variant="outlined" className={classes.paper}>
    <FormGroup row className={classes.formgroup}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Accounts Double Check
        </Typography>
        <Button
          expand={expanded1}
          onClick={()=>setexpanded1(!expanded1)}
          aria-expanded={expanded1}
          aria-label="show more"
        >
        
          {expanded1?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <Collapse in={expanded1} timeout="auto" unmountOnExit>
        <div align="center">
        
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(loadpayment2)}
          >
            Load
          </Button>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(futuretripsonly)}
          >
            Future
          </Button>
        
        </div>
        

        <div style={{ height: 600, width: "100%" }}>
          <DataGrid
            rows={paymentdatalistdisplaycheck}
            onCellDoubleClick={(getValue) =>
              gridcellclickpayment(getValue.row.trip_id)
            }
            columns={pcolumns3}
            // pageSize={5}
            // pageSizeOptions={[5]}
            autoPageSize
            //sortModel={sortModel}
            // onSortModelChange={(model) => setSortModel(model)}
            //utoHeight
          ></DataGrid>
        </div>
        </Collapse>
      </Paper>

      
      </div>):("")}

      {role=="Sales"  || role=="SME" ? (<div>
        <Paper variant="outlined" className={classes.paper}>   
        <Typography variant="h5" align="center" className={classes.headertext}><a onClick={showqp}>Quote Pending: {qpData.length}</a> || <a onClick={showmissed}>Missed Calls: {missedcall.length}</a></Typography>
        </Paper>
    <Paper variant="outlined" className={classes.paper}>
    <FormGroup row className={classes.formgroup}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Pending Converted Trips
        </Typography>
        <Button
          expand={expanded15}
          onClick={()=>setexpanded15(!expanded15)}
          aria-expanded={expanded15}
          aria-label="show more"
        >
        
          {expanded15?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <Collapse in={expanded15} timeout="auto" unmountOnExit>
        <div align="center">
        
          {/* <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={loadpayment}
          >
            Load
          </Button> */}
          
        
        </div>
        

        <div style={{ height: 600, width: "100%" }}>
          <DataGrid
            rows={requestedtriplistcheck}
            onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
            columns={tcolumns2}
            // pageSize={5}
            // pageSizeOptions={[5]}
            autoPageSize
            //sortModel={sortModel}
            // onSortModelChange={(model) => setSortModel(model)}
            //utoHeight
          ></DataGrid>
        </div>
        </Collapse>
      </Paper>

      
      </div>):("")}
    
    {/* </FormGroup> */}

      {role=="Admin" || role=="Sales"  || role=="SME" || role=="TL" || role=="Product" || role=="Manager"? (<div>
       {/* Cancel trips */}
      <Paper variant="outlined" className={classes.paper}>
      <FormGroup row className={classes.formgroup}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Trips marked for cancellation
        </Typography>
        <Button
          expand={expanded2}
          onClick={()=>setexpanded2(!expanded2)}
          aria-expanded={expanded2}
          aria-label="show more"
        >
          {expanded2?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <Collapse in={expanded2} timeout="auto" unmountOnExit>
        <div align="center">
        <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="assign">Trip Owner</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Assign To" value={filterData3.trip_owner} onChange={(e)=> setfilterData3({...filterData3, trip_owner: e.target.value})}>
              
                <MenuItem value={""}>Clear</MenuItem>
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
              
                    
                
                </Select>
                </FormControl>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(loadtripcanc)}
          >
            Load
          </Button>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={addselection2}
          >
            Cancel
          </Button>
        
        </div>
        

        <div style={{ height: 1000, width: "100%" }}>
          <DataGrid
            rows={cancflagdatalistdisplay}
            onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
            columns={canccolumns3}
            checkboxSelection={true}
            onSelectionModelChange={(newSelection) => {
              //console.log(newSelection)
            setselection2(newSelection);}}
            // pageSize={5}
            // pageSizeOptions={[5]}
            autoPageSize
            //sortModel={sortModel}
            // onSortModelChange={(model) => setSortModel(model)}
            //utoHeight
          ></DataGrid>
        </div>
        </Collapse>
      </Paper>
      </div>):("")}
            {/* Payment collection */}
      <Paper variant="outlined" className={classes.paper}>
      <FormGroup row className={classes.formgroup}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Payment Collection Reminders
        </Typography>
        <Button
          expand={expanded3}
          onClick={()=>setexpanded3(!expanded3)}
          aria-expanded={expanded3}
          aria-label="show more"
        >
          {expanded3?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <Collapse in={expanded3} timeout="auto" unmountOnExit>
        <div align="center">
        
          {/* <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={changeisOwner}
          >
            {isOwner ? "Show for all" : "Show for user"}
          </Button> */}
          {role=="Admin" || role=="TL" || role=="Support" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Accounts" || role=="Manager"? (<div>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(loadpayment)}
          >
            Load
          </Button>
        </div>):("")}
        
        </div>
        

        <div style={{ height: 800, width: "100%" }}>
          <DataGrid
            rows={paymentdatalistdisplay}
            onCellDoubleClick={(getValue) =>
              gridcellclickpayment(getValue.row.trip_id)
            }
            columns={pcolumns}
            autoPageSize
            // pageSize={5}
            // //sortModel={sortModel}
            // // onSortModelChange={(model) => setSortModel(model)}
            // autoHeight
          ></DataGrid>
        </div>
        </Collapse>
      </Paper>
      {role=="Admin" || role=="Support" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Accounts"? (<div>
      {/* Supplier payment */}
      <Paper variant="outlined" className={classes.paper}>
      <FormGroup row className={classes.formgroup}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Supplier Payment Reminders
        </Typography>
        <Button
          expand={expanded4}
          onClick={()=>setexpanded4(!expanded4)}
          aria-expanded={expanded4}
          aria-label="show more"
        >
          {expanded4?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <Collapse in={expanded4} timeout="auto" unmountOnExit>
        <div align="center">
        
          {/* <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={changeisOwner}
          >
            {isOwner ? "Show for all" : "Show for user"}
          </Button> */}
          {role=="Admin" || role=="TL" || role=="Support" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Accounts"? (<div>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(loadpayment)}
          >
            Load
          </Button>
        </div>):("")}
        
        </div>
         {role && (role=="Admin" || role=="Product") && suppaymentdatalistdisplay.length>1?(<div>
                               <CSVLink data={suppaymentdatalistdisplay} headers={pheaders2}>Download CSV</CSVLink>
                               </div>
                            ):("")}

        <div style={{ height: 400, width: "100%" }}>
          <DataGrid
            rows={suppaymentdatalistdisplay}
            onCellDoubleClick={(getValue) =>
              gridcellclickpayment(getValue.row.trip_id)
            }
            columns={pcolumns2}
            autoPageSize
            // pageSize={5}
            // //sortModel={sortModel}
            // // onSortModelChange={(model) => setSortModel(model)}
            // autoHeight
          ></DataGrid>
        </div>
        {/* <div style={{ height: 400, width: "100%" }}>
          <DataGrid
            rows={suppaydue}
            onCellDoubleClick={(getValue) =>
              gridcellclickpayment(getValue.row.trip_id)
            }
            columns={duecolumns}
            autoPageSize
            // pageSize={5}
            // //sortModel={sortModel}
            // // onSortModelChange={(model) => setSortModel(model)}
            // autoHeight
          ></DataGrid>
        </div> */}
        </Collapse>
      </Paper>
      {/* Pending Bookings */}
      <Paper variant="outlined" className={classes.paper}>
      <FormGroup row className={classes.formgroup}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Pending Bookings
        </Typography>
        <Button
          expand={expanded5}
          onClick={()=>setexpanded5(!expanded5)}
          aria-expanded={expanded5}
          aria-label="show more"
        >
          {expanded5?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <Collapse in={expanded5} timeout="auto" unmountOnExit>
        <div align="center">
        
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(getconvtrips)}
          >
            Load
          </Button>
       
        
        </div>
        

        <div style={{ height: 400, width: "100%" }}>
          <DataGrid
            rows={convdatalistdisplaycheck}
            onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
            columns={convcolumns}
            autoPageSize
            // pageSize={5}
            // //sortModel={sortModel}
            // // onSortModelChange={(model) => setSortModel(model)}
            // autoHeight
          ></DataGrid>
        </div>
        </Collapse>
      </Paper>
      {/* Operations Bookings */}
      <Paper variant="outlined" className={classes.paper}>
      <FormGroup row className={classes.formgroup}>
      
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Operation Reminders
        </Typography>
        <Button
          expand={expanded6}
          onClick={()=>setexpanded6(!expanded6)}
          aria-expanded={expanded6}
          aria-label="show more"
        >
          {expanded6?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <Collapse in={expanded6} timeout="auto" unmountOnExit>
        <div align="center">
        <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="trip owner">Trip Owner</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Trip Owner" value={opsfilterData.owner} onChange={(e)=> setopsfilterData({...opsfilterData, owner: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
               
                {opsemp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
              
                    
                
                </Select>
                </FormControl>
         
          {role=="Admin" || role=="TL" || role=="Support" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Manager"? (<div>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(loadops)}
          >
            Load
          </Button>
        </div>):("")}
        
        </div>
        

        <div style={{ height: 600, width: "100%" }}>
          <DataGrid
            rows={opsdatalistdisplay}
            onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
            columns={ocolumns}
            autoPageSize
            // pageSize={8}
            // //sortModel={sortModel}
            // // onSortModelChange={(model) => setSortModel(model)}
            // autoHeight
          ></DataGrid>
        </div>
        </Collapse>
      </Paper>
      </div>):("")}
      {/* Lead reminder */}
      {(role=="Admin" || role=="TL" || role=="Manager" || role=="Sales" || role=="Sales Support") && cuser!=="KiranRana"?(
      
      <Paper variant="outlined" className={classes.paper}>
      <FormGroup row className={classes.formgroup}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Lead Reminders
        </Typography>
        <br></br>
        {leaddatalistdisplay.length>1?(<Typography variant="h6" align="center" className={classes.headertext}>{opencust.length+" open customers assigned to non-sales. Assign them first before assigning leads"}</Typography>):("")}
        <Button
          expand={expanded9}
          onClick={()=>setexpanded9(!expanded9)}
          aria-expanded={expanded9}
          aria-label="show more"
        >
          {expanded9?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <Collapse in={expanded9} timeout="auto" unmountOnExit>
        <div align="center">
        <FormGroup row className={classes.formgroup}>
          {/* <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={changeisOwner}
          >
            {isOwner ? "Show for all" : "Show for user"}
          </Button> */}
          {role=="Sales"  || role=="SME" ?(
            <div>
            <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(()=>getleadtodaybyowner(cuser))}
          >
            Today Leads
          </Button>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={()=>setdefaultleadData(!defaultleadData)}
          >
            Default
          </Button>
          </div>
          ):("")}
          {role=="Admin" || role=="TL" || role=="Support" || role=="Operations"  || role=="Operations-TL" || role=="Product" || role=="Manager"? (<div>
            <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={getLead2}
          >
            HQ Leads
          </Button>
          <Button
            variant="contained"
            color="Inherit"
            id="HQLeadsNew"
            className={classes.button}
            onClick={preventDoubleClick(getLead3)}
          >
            HQ Leads-New
          </Button>
          
          <Button
            variant="contained"
            color="Inherit"
            id="HQLeadsNew"
            className={classes.button}
            onClick={preventDoubleClick(getfunnelsize)}
          >
            Funnel Size
          </Button>
          
        </div>):("")}
        {role=="Admin" ? (<div>
         
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(loadlead)}
          >
            Load
          </Button>
          
        </div>):("")}
        {role=="Admin" || role=="Manager" || cuser=="Tarun" ? (<div>
         
         <Button
           variant="contained"
           color="primary"
           className={classes.button}
           onClick={()=>setcopon(!copon)}
         >
           {copon?"LQ On":"LQ Off"}
         </Button>
         <Button
            variant="contained"
            color="Inherit"
             id="LQLeadsNew"
            className={classes.button}
            onClick={getLead4}
          >
            LQ Leads
          </Button>
         
       </div>):("")}
        </FormGroup>
        </div>
        <div>
        {role=="Admin" || role=="TL" || role=="Support" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Manager"? (<div>
        
        <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="trip owner">Trip Owner</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Trip Owner" value={leadfilterData.trip_owner} onChange={(e)=> setleadfilterData({...leadfilterData, trip_owner: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Amit"}>Amit</MenuItem>
               <MenuItem value={"Abhishek"}>Abhishek</MenuItem>
               <MenuItem value={"RohitS"}>RohitS</MenuItem>
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
              
                    
                
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="assign">Assign To</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Assign To" value={leadfilterData.assign_to} onChange={(e)=> setleadfilterData({...leadfilterData, assign_to: e.target.value})}>
                <MenuItem value={"Amit"}>Amit</MenuItem>
               <MenuItem value={"Abhishek"}>Abhishek</MenuItem>
               <MenuItem value={"RohitS"}>RohitS</MenuItem>
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
              
                    
                
                </Select>
                </FormControl>
                {/* <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={assign}
          > Assign
          </Button> */}
          <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={addselection}
          > Add
          </Button>
          {(role=="Admin" || role=="Manager" ||(role=="TL" && (new Date().getTime()<d.getTime() || new Date().getTime()>c.getTime()))) && leadselectionData.length>0?(
          <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={preventDoubleClick(newassign)}
          > New Assign
          </Button>
          ):("")}
          {leaddatalistdisplay.length>1?(
            <div>
            <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={()=>showleadbreakup()}
            
          > Status
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={()=>setOpen(true)}
          > Details
          </Button>
          </div>
          ):("")}
          
                </div>):("")}
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Destination">Destination</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Destination" value={leadfilterData.destination} onChange={(e)=> setleadfilterData({...leadfilterData, destination: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Bali"}>Bali</MenuItem>
                {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
                    
                    
                
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Higherpax">Higher Pax</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Higherpax" value={leadfilterData.higherpax} onChange={(e)=> setleadfilterData({...leadfilterData, higherpax: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={0}>0</MenuItem>
                                
                    
                
                </Select>
                </FormControl>
                <FormControl
          style={{
            minWidth: 240,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="fastreach">Fast Reach</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="fastreach"
            // value={leadfilterData.qu}
            onChange={(e)=> setleadfilterData({...leadfilterData, fastreach: e.target.value})}
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={0}>0</MenuItem>
            
          </Select>
        </FormControl>


           </div>
           {defaultleadData?(<div style={{ height: 1000, width: "100%" }}>
          <DataGrid
            rows={leaddatalistdisplay}
            onCellDoubleClick={(getValue) =>
              gridcellclicklead(getValue.row.lead_id)
            }
            columns={role=="Sales"  || role=="SME" || role=="TL"?lcolumns2:lcolumns}
            checkboxSelection={true}
            onSelectionModelChange={(newSelection) => {
            setselection(newSelection);}}
            autoPageSize
            // pageSize={15}
            //autoHeight
          ></DataGrid>
        </div>):(<div style={{ height: 1000, width: "100%" }}>
          <DataGrid
            rows={leaddatalistdisplay2}
            onCellDoubleClick={(getValue) =>
              gridcellclicklead(getValue.row.lead_id)
            }
            columns={role=="Sales"  || role=="SME" || role=="TL"?lcolumns2:lcolumns}
            checkboxSelection={true}
            onSelectionModelChange={(newSelection) => {
            setselection2(newSelection);}}
            autoPageSize
            // pageSize={15}
            //autoHeight
          ></DataGrid>
        </div>)}
        </Collapse>
      </Paper>
      ):("")}
      {/* Cust followup */}
      <Paper variant="outlined" className={classes.paper}>
      <FormGroup row className={classes.formgroup}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          View Customer Followups
        </Typography>
        <Button
          expand={expanded10}
          onClick={()=>setexpanded10(!expanded10)}
          aria-expanded={expanded10}
          aria-label="show more"
        >
          {expanded10?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <Collapse in={expanded10} timeout="auto" unmountOnExit>
        <div align="center">
        <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="trip owner">Trip Owner</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Trip Owner" value={filterData.trip_owner} onChange={(e)=> setfilterData({...filterData, trip_owner: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Amit"}>Amit</MenuItem>
                {salesemp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
              
                    
                
                </Select>
                </FormControl>
                <FormControlLabel control={<Checkbox color="primary"/>}  value={showall} checked={showall} label="Show All?" onChange={(e)=> setshowall(e.target.checked)}/>
          {role=="Admin" || role=="TL" || role=="Support" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Manager"? (<div>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(loadcust)}
          >
            Load
          </Button>
        </div>):("")}
        </div>
        <div align="center">
        <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="assign">Assign To</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Assign To" value={leadfilterData.cust_assign_to} onChange={(e)=> setleadfilterData({...leadfilterData, cust_assign_to: e.target.value})}>
                <MenuItem value={"Amit"}>Amit</MenuItem>
               <MenuItem value={"Abhishek"}>Abhishek</MenuItem>
               <MenuItem value={"RohitS"}>RohitS</MenuItem>
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
              
                    
                
                </Select>
                </FormControl>
             <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={addselection3}
          > Add
          </Button>
          {role=="Admin" || role=="Manager" ?(
          <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={preventDoubleClick(newcustassign)}
          > New Assign
          </Button>
          ):("")}
        </div>

        <div style={{ height: 1000, width: "100%" }}>
          <DataGrid
            rows={custfollowupdatalistdisplay}
            onCellDoubleClick={(getValue) =>
              custcellclick(getValue.row.cust_id)
            }
            columns={ccolumns}
            autoPageSize
            checkboxSelection={true}
            onSelectionModelChange={(newSelection) => {
            setselection3(newSelection);}}
          ></DataGrid>
        </div>
        </Collapse>
      </Paper>
      {/* Open followup */}
      <Paper variant="outlined" className={classes.paper}>
      <FormGroup row className={classes.formgroup}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          View open Followups
        </Typography>
        <Button
          expand={expanded11}
          onClick={()=>setexpanded11(!expanded11)}
          aria-expanded={expanded11}
          aria-label="show more"
        >
          {expanded11?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <Collapse in={expanded11} timeout="auto" unmountOnExit>
        <div align="center">
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={change0000}
          >
            {show0000 ? "Show prev" : "Show new"}
          </Button>
          <Tooltip title="Show FUP till today or of future">
          <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={changefollowup}
          >
            {tdfup ? "Show All" : "Show today"}
          </Button>
          </Tooltip>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            href="/searchtrip"
          >
            Search Cancelled
          </Button>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={()=>get12pm(cuser)}
          >
            12pm report
          </Button>
          {role=="Admin" || role=="TL" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Manager" || role=="Sales Support"? (<div>
          <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={preventDoubleClick(getFollowups)}
          >
            Load
          </Button>
         <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(getFollowups2)}
          >
            Present SP Only
          </Button>
          
     
        </div>):("")}
        </div>
        <br></br>
        {role=="Admin" || role=="TL" || role=="Manager"?(<div>
        <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="trip owner">Trip Owner</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Trip Owner" value={filterData.trip_owner} onChange={(e)=> setfilterData({...filterData, trip_owner: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Amit"}>Amit</MenuItem>
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
              
                    
                
                </Select>
                </FormControl>
                </div>):("")}
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="trip status">Trip Status</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Trip Status" value={filterData.trip_status} onChange={(e)=> setfilterData({...filterData, trip_status: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"New"}>New</MenuItem>
                    <MenuItem value={"Active"}>Active</MenuItem>
                    <MenuItem value={"Closed"}>Closed</MenuItem>
                    <MenuItem value={"Hot"}>Hot</MenuItem>
                    <MenuItem value={"Converted"}>Converted</MenuItem>
                    <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                    <MenuItem value={"Postponed"}>Postponed</MenuItem>
                    <MenuItem value={"Booked Outside"}>Booked Outside</MenuItem>
                    
                    
                
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 120, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="callmust">Call Must?</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="callmust" value={filterData2.call_must} onChange={(e)=> setfilterData({...filterData, call_must: e.target.value})}>
                <MenuItem value={"True"}>True</MenuItem>
                <MenuItem value={"False"}>False</MenuItem>
                
              
                    
                
                </Select>
                </FormControl>
                {/* <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={(e)=> setfilterData({...filterData, trip_status: "", trip_owner:""})}
          >
            Clear
          </Button> */}

        <div style={{ height: 2400, width: "100%" }}>
        {role=="Admin"?(
          <DataGrid
            rows={show0000?followupdatalistdisplay01:followupdatalistdisplay}
            onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
            columns={fcolumns2}
            autoPageSize
            // pageSize={40}
            // //sortModel={sortModel}
            // //onSortModelChange={(model) => setsortModel(model)}
            // autoHeight
          ></DataGrid>
        ):(
          <DataGrid
            rows={show0000?followupdatalistdisplay00:followupdatalistdisplay}
            onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
            columns={fcolumns}
            autoPageSize
            // pageSize={40}
            // //sortModel={sortModel}
            // //onSortModelChange={(model) => setsortModel(model)}
            // autoHeight
          ></DataGrid>
        )}
          
        </div>
        </Collapse>
      </Paper>
       {role=="Admin" || role=="TL" || role=="Manager"?(
        <Paper variant="outlined" className={classes.paper}>
        <FormGroup row className={classes.formgroup}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          View All Followups
        </Typography>
        <Button
          expand={expanded12}
          onClick={()=>setexpanded12(!expanded12)}
          aria-expanded={expanded12}
          aria-label="show more"
        >
          {expanded12?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <Collapse in={expanded12} timeout="auto" unmountOnExit>
        <div align="center">
        <FormGroup row className={classes.formgroup}>
        <FormControl style={{minWidth: 120, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="trip owner">Trip Owner</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Trip Owner" value={filterData.trip_owner} onChange={(e)=> setfilterData2({...filterData2, trip_owner: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Amit"}>Amit</MenuItem>
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
              
                    
                
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 120, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="date">Date</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Date" value={filterData.trip_owner} onChange={(e)=> setfilterData2({...filterData2, date: e.target.value})}>
                <MenuItem value={"D"}>D</MenuItem>
                <MenuItem value={"D-1"}>D-1</MenuItem>
                <MenuItem value={"D-2"}>D-2</MenuItem>
                </Select>
                </FormControl>    
                <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(getallFollowups)}
          >
            Load
          </Button>
                <FormControl style={{minWidth: 120, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="callmust">Call Must?</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="callmust" value={filterData2.call_must} onChange={(e)=> setfilterData2({...filterData2, call_must: e.target.value})}>
                <MenuItem value={"True"}>True</MenuItem>
                <MenuItem value={"False"}>False</MenuItem>
                
              
                    
                
                </Select>
                </FormControl>
          
          
          </FormGroup>
        </div>
        
        
                {/* <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="trip status">Trip Status</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Trip Status" value={filterData.trip_status} onChange={(e)=> setfilterData({...filterData, trip_status: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"New"}>New</MenuItem>
                    <MenuItem value={"Active"}>Active</MenuItem>
                    <MenuItem value={"Closed"}>Closed</MenuItem>
                    <MenuItem value={"Hot"}>Hot</MenuItem>
                    <MenuItem value={"Converted"}>Converted</MenuItem>
                    <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                    <MenuItem value={"Postponed"}>Postponed</MenuItem>
                    <MenuItem value={"Booked Outside"}>Booked Outside</MenuItem>
                    
                    
                
                </Select>
                </FormControl> */}
                {/* <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={(e)=> setfilterData2({...filterData2, trip_status: "", trip_owner:""})}
          >
            Clear
          </Button> */}

        <div style={{ height: 2400, width: "100%" }}>
          <DataGrid
            rows={allfollowupdatalistdisplay}
            onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
            columns={fcolumns3}
            autoPageSize
            // pageSize={40}
            // //sortModel={sortModel}
            // //onSortModelChange={(model) => setsortModel(model)}
            // autoHeight
          ></DataGrid>
          
        </div>
        </Collapse>
      </Paper>
       ):("")}   
        {/* FUP Check */}
      <Paper variant="outlined" className={classes.paper}>
      <FormGroup row className={classes.formgroup}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          FUP Check
        </Typography>
        <Button
          expand={expanded27}
          onClick={()=>setexpanded27(!expanded27)}
          aria-expanded={expanded27}
          aria-label="show more"
        >
          {expanded27?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <Collapse in={expanded27} timeout="auto" unmountOnExit>
        <div align="center">
        <FormGroup row className={classes.formgroup}>
       
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(loadfupcheck)}
          >
            Load
          </Button>
         <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="trip owner">Trip Owner</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Trip Owner" value={filterData7.trip_owner} onChange={(e)=> setfilterData7({...filterData7, trip_owner: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Amit"}>Amit</MenuItem>
               <MenuItem value={"Abhishek"}>Abhishek</MenuItem>
               <MenuItem value={"RohitS"}>RohitS</MenuItem>
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
              
                    
                
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="status">Status</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Status" value={filterData7.status} onChange={(e)=> setfilterData7({...filterData7, status: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Open"}>Open</MenuItem>
               <MenuItem value={"Closed"}>Closed</MenuItem>           
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="called_today">Called Today</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Trip Owner" value={filterData7.called_today} onChange={(e)=> setfilterData7({...filterData7, called_today: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Yes"}>Yes</MenuItem>
               <MenuItem value={"No"}>No</MenuItem>
              
              
                    
                
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="created">Created</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Trip Owner" value={filterData7.created} onChange={(e)=> setfilterData7({...filterData7, created: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Today"}>Today</MenuItem>
               <MenuItem value={"Past"}>Past</MenuItem>
              
              
                    
                
                </Select>
                </FormControl>
      
        </FormGroup>
        </div>
              {role && (role=="Admin" || role=="Manager" || role=="TL") && fupcheckdisplay.length>1?(<div>
                               <CSVLink data={fupcheckdisplay} headers={fupheaders}>Download CSV</CSVLink>
                               </div>
                            ):("")}
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            rows={fupcheckdisplay}
            onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
            columns={fupcolumns}
            autoPageSize
            // pageSize={5}
            // //sortModel={sortModel}
            // // onSortModelChange={(model) => setSortModel(model)}
            // autoHeight
          ></DataGrid>
        </div>
        </Collapse>
      </Paper>  
      {/* Task Reminder */}
      <Paper variant="outlined" className={classes.paper}>
      <FormGroup row className={classes.formgroup}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Ticket Reminders
        </Typography>
        <Button
          expand={expanded7}
          onClick={()=>setexpanded7(!expanded7)}
          aria-expanded={expanded7}
          aria-label="show more"
        >
          {expanded7?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <Collapse in={expanded7} timeout="auto" unmountOnExit>
        <div align="center">
        <FormGroup row className={classes.formgroup}>
        <Button
            variant="contained"
            color="primary"
            className={classes.button}
            href={"/taskdataentry"}
          >Create Ticket</Button>
          {role=="Admin" || role=="TL"  || role=="Manager" || role=="Operations-TL" || role=="Product"? (<div>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(()=>getTasks())}
          >
            Load
          </Button>
         
        </div>):("")}
        </FormGroup>
        </div>

        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            rows={taskdatalistdisplay}
            onCellDoubleClick={(getValue) =>
              gridcellclicktask(getValue.row.task_id)
            }
            columns={tcolumns}
            autoPageSize
            // pageSize={5}
            // //sortModel={sortModel}
            // // onSortModelChange={(model) => setSortModel(model)}
            // autoHeight
          ></DataGrid>
        </div>
        </Collapse>
      </Paper>
            {/* PS Reminder */}
      <Paper variant="outlined" className={classes.paper}>
      <FormGroup row className={classes.formgroup}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Upcoming Trips Reminders
        </Typography>
        <Button
          expand={expanded8}
          onClick={()=>setexpanded8(!expanded8)}
          aria-expanded={expanded8}
          aria-label="show more"
        >
          {expanded8?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <Collapse in={expanded8} timeout="auto" unmountOnExit>
        <div align="center">
          {/* <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={changeisOwner}
          >
            {isOwner ? "Show for all" : "Show for user"}
          </Button> */}
          {role=="Admin" || role=="TL" || role=="Support" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Manager"? (<div>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(loadpayment)}
          >
            Load
          </Button>
        </div>):("")}
        </div>

        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            rows={postsalesdatalistdisplay}
            onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
            columns={pscolumns}
            autoPageSize
            // pageSize={5}
            // //sortModel={sortModel}
            // // onSortModelChange={(model) => setSortModel(model)}
            // autoHeight
          ></DataGrid>
        </div>
        </Collapse>
      </Paper>
     
      <Paper variant="outlined" className={classes.paper}>
      <FormGroup row className={classes.formgroup}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Trips within 7 days
        </Typography>
     
        <Button
          expand={expanded13}
          onClick={()=>setexpanded13(!expanded13)}
          aria-expanded={expanded13}
          aria-label="show more"
        >
          {expanded13?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <Collapse in={expanded13} timeout="auto" unmountOnExit>
        {role=="Admin" || role=="TL" || role=="Support" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Manager"? (<div>
        <div align="center">
          {/* <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={changeisOwner}
          >
            {isOwner ? "Show for all" : "Show for user"}
          </Button> */}
          
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(loadsd)}
          >
            Load
          </Button>
       
        </div>
        </div>):("")}
        <div style={{ height: 800, width: "100%" }}>
          <DataGrid
            rows={sddatalistdisplay}
            onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
            columns={sdcolumns}
            autoPageSize
            // pageSize={10}
            // //sortModel={sortModel}
            // // onSortModelChange={(model) => setSortModel(model)}
            // autoHeight
          ></DataGrid>
        </div>
        </Collapse>
      </Paper>
      {role=="Sales"  || role=="SME" ?(
        <div>
      <Paper variant="outlined" className={classes.paper}>
      <FormGroup row className={classes.formgroup}>
      <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Quotes Created Today
        </Typography>
        <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(()=>handlequoteSearch(cuser))}
          >
            Fetch
          </Button>
        <Button
          expand={expanded16}
          onClick={()=>setexpanded16(!expanded16)}
          aria-expanded={expanded16}
          aria-label="show more"
        >
          {expanded16?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <div style={{ height: 800, width: "100%" }}>
          <DataGrid
            rows={quotescreated}
            onCellDoubleClick={(getValue) =>
              gridcellclickquote(getValue.row.quote_id)
            }
            columns={qcolumns}
            autoPageSize
            // pageSize={10}
            // //sortModel={sortModel}
            // // onSortModelChange={(model) => setSortModel(model)}
            // autoHeight
          ></DataGrid>
         
        </div>
      </Paper>
      
      <Paper variant="outlined" className={classes.paper}>
      <FormGroup row className={classes.formgroup}>
      <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Quotes Edited Today
        </Typography>
        <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(()=>handlequoteSearch(cuser))}
          >
            Fetch
          </Button>
          <Button
          expand={expanded17}
          onClick={()=>setexpanded17(!expanded17)}
          aria-expanded={expanded17}
          aria-label="show more"
        >
          {expanded17?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <div style={{ height: 800, width: "100%" }}>
       
          <DataGrid
            rows={quotesedited}
            onCellDoubleClick={(getValue) =>
              gridcellclickquote(getValue.row.quote_id)
            }
            columns={qcolumns2}
            autoPageSize
            // pageSize={10}
            // //sortModel={sortModel}
            // // onSortModelChange={(model) => setSortModel(model)}
            // autoHeight
          ></DataGrid>
          
        </div>
      </Paper>
      </div>
      ):("")}    
      <Paper variant="outlined" className={classes.paper}>
      <FormGroup row className={classes.formgroup}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Cancelled in last 3 days
        </Typography>
        {role!=="Admin"?(
        <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(()=>getCancbyOwner(cuser, cancdate))}
          >
            Fetch
          </Button>
        ):("")}
        <Button
          expand={expanded14}
          onClick={()=>setexpanded14(!expanded14)}
          aria-expanded={expanded14}
          aria-label="show more"
        >
          {expanded14?<ExpandLessIcon />:<ExpandMoreIcon />}
        </Button>
        </FormGroup>
        <Collapse in={expanded14} timeout="auto" unmountOnExit>
        <div align="center">
        <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="trip owner">Trip Owner</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Trip Owner" value={filterData.trip_owner} onChange={(e)=> setfilterData({...filterData, trip_owner: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Amit"}>Amit</MenuItem>
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
              
                    
                
                </Select>
                </FormControl>
          {role=="Admin" || role=="TL" || role=="Support" || role=="Operations" || role=="Operations-TL" || role=="Product"? (<div>
          <Button
            variant="contained"
            color="Inherit"
            className={classes.button}
            onClick={preventDoubleClick(loadcanc)}
          >
            Load
          </Button>
        </div>):("")}
        </div>
             {role=="Admin" && cancdatalistdisplay2.length>1?(<div>
                               <CSVLink data={cancdatalistdisplay2} headers={cancheaders}>Download CSV</CSVLink>
                               </div>
                            ):("")}
        <div style={{ height: 1200, width: "100%" }}>
        {role=="Admin" || role=="TL"?(
          <DataGrid
            rows={cancdatalistdisplay2}
            onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
            columns={canccolumns2}
            autoPageSize
            // pageSize={20}
            // //sortModel={sortModel}
            // // onSortModelChange={(model) => setSortModel(model)}
            // autoHeight
          ></DataGrid>
        ):(
          <DataGrid
            rows={cancdatalistdisplay}
            onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
            columns={canccolumns}
            autoPageSize
            // pageSize={20}
            // //sortModel={sortModel}
            // // onSortModelChange={(model) => setSortModel(model)}
            // autoHeight
          ></DataGrid>
        )}
          
        </div>
        </Collapse>
      </Paper>
    </div>
    ):("Loading...")}
     </div>
   
      ):("")}
      </div>
  );
};

export default Homeview;
